export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "PO-Revision-Date": "2024-08-29T04:43:11.859Z",
    "Last-Translator": "",
    "Language-Team": "",
    "Language": "en-US",
    "Messages": {
        "3": "3",
        "5": "5",
        "10": "10",
        "-": "-",
        "...nie znalazłeś treści? Utwórz nową.": "...can't find what you're looking for? Create a new one.",
        "{count} odpowiedzi": "{count} answers",
        "{seconds} sek.": "{seconds} sec.",
        "1. Wybierz wzór": "1. Select a template",
        "2 kolumny 25/75": "2 columns 25/75",
        "2 kolumny 33/66": "2 columns 33/66",
        "2 kolumny 50/50": "2 columns 50/50",
        "2 kolumny 66/33": "2 columns 66/33",
        "2 kolumny 75/25": "2 columns 75/25",
        "2. Wybierz wpis": "2. Select an entry",
        "3 kolumny": "3 columns",
        "3 kolumny 25/25/50": "3 columns 25/25/50",
        "3 kolumny 25/50/25": "3 columns 25/50/25",
        "3 kolumny 50/25/25": "3 columns 50/25/25",
        "3. Konfiguruj i wstaw": "3. Configure and insert",
        "4 kolumny": "4 columns",
        "A11y": "A11y",
        "A11y i SEO": "A11y and SEO",
        "Aby nastąpiła automatyczna akceptacja regulaminu, wybrana wersja musi mieć status „Do akceptacji”.": "For automatic approval of the terms and conditions, selected version must have status “Pending approval”.",
        "Adres": "Address",
        "Adres docelowy": "Destination address",
        "Adres domenowy": "Domain address",
        "Adres domeny": "Domain address",
        "Adres e-mail": "Email address",
        "Adres IP": "IP address",
        "Adres kanoniczny": "Canonical address",
        "Adres linku": "Link address",
        "Adres otwierany po kliknięciu bannera.": "Address opened when banner is clicked.",
        "Adres strony": "Website address",
        "Adres tematu oraz jego zasięg.": "Topic address and its scope.",
        "Adres url": "Url",
        "Adres URL": "URL",
        "Adres url do pliku wideo": "Url to video file",
        "Adres URL profilu autora.": "URL of the author profile.",
        "Adres został skopiowany.": "Address has been copied.",
        "Adres źródłowy": "Source address",
        "Adresy w obrębie tej samej domeny podawaj jako pełne ścieżki, np. /stara-strona oraz /nowa-strona.": "Enter addresses within same domain as full paths, e.g. /old-page and /new-page.",
        "Adresy witryny korzystają z HTTPS zamiast HTTP.": "Website addresses use HTTPS instead of HTTP.",
        "AI": "AI",
        "AI w wynikach Google Search": "AI in Google Search results",
        "Akceptacja komentarzy": "Accept comments",
        "Akceptuj": "Accept",
        "Akcje ceny": "Price actions",
        "Akcje listy: {name}": "List actions: {name}",
        "Akcje sekcji": "Section actions",
        "Akcje treści": "Content actions",
        "Akcje widżetu": "Widget actions",
        "Akcje widżetu {name}": "Widget actions {name}",
        "Aktualna": "Current",
        "Aktualności": "News",
        "Aktualności ze strony": "Website news",
        "Aktywacja kont po rejestracji": "Activation of accounts after registration",
        "Aktywna": "Active",
        "Aktywne": "Active",
        "Aktywne do": "Active to",
        "Aktywne kanały:": "Active channels:",
        "Aktywne od": "Active since",
        "Aktywne teraz": "Active now",
        "Aktywni użytkownicy": "Active users",
        "Aktywność użytkowników w ostatnich 30 minutach": "User activity in last 30 minutes",
        "Aktywny": "Active",
        "Aktywuj": "Activate",
        "Aktywuj przerwę techniczną w witrynie": "Activate the site's technical break",
        "Alfabetycznie": "Alphabetically",
        "Alternatywna": "Alternative",
        "Angielski": "English",
        "Ankieta": "Survey",
        "Ankieta dołączona do artykułu": "Survey attached to article",
        "Ankieta nie ma jeszcze głosów": "Survey has no votes yet",
        "Ankieta wyświetli się w miejscu wskazanym w treści artykułu. Aby je wskazać wybierz element \"Ankieta\" z narzędzi edytora": "Survey will appear at position indicated in article content. To specify position, select \"Survey\" element from editor tools",
        "Ankiety": "Surveys",
        "Anulowane": "Canceled",
        "Anuluj": "Cancel",
        "Anuluj edycję": "Undo",
        "Aranżacja": "Layout",
        "Aranżacja alternatywna": "Alternative arrangement",
        "Aranżacja domyślna": "Default arrangement",
        "Aranżacja główna": "Main arrangement",
        "Aranżacja i moduł": "Layout and module",
        "Aranżacja nie jest przypisana do żadnej strony": "Layout is not assigned to any page",
        "Aranżacja została dodana.": "The arrangement has been added.",
        "Aranżacja została skopiowana.": "Layout has been copied.",
        "Aranżacja została usunięta.": "The arrangement has been deleted.",
        "Aranżacja została zaktualizowana.": "The arrangement has been updated.",
        "Aranżacje": "Arrangements",
        "Aranżacje docelowe": "Target layouts",
        "Archiwum": "Archive",
        "artykuł": "article",
        "Artykuł": "Article",
        "Artykuł na całą szerokość": "Full-width article",
        "Artykuł otwarty": "Open article",
        "Artykuł premium": "Premium Article",
        "Artykuł sponsorowany": "Sponsored article",
        "artykułów": "articles",
        "artykuły": "articles",
        "Artykuły": "Articles",
        "Artykuły oznaczone jako \"Śródtekstowe\" wyświetlą się w miejscu wskazanym w treści artykułu. Aby je wskazać wybierz element \"Powiązane artykuły\" z narzędzi edytora": "Articles marked as \"In-text\" will appear at position indicated in article content. To specify position, select \"Related articles\" element from editor tools",
        "Artykuły ze statusem PRIORYTET": "Articles with PRIORITY status",
        "Asystent AI": "AI assistant",
        "Asystent nie zwrócił treści. Spróbuj ponownie.": "Assistant didn't return any content. Try again.",
        "Asystent odpowie na podstawie treści artykułu – możesz też poprosić o przeredagowanie zaznaczonego fragmentu.": "Assistant will respond based on article content – you can also ask it to rewrite selected text.",
        "Automat paczkowy": "Parcel locker",
        "Automatyczna akceptacja": "Auto acceptance",
        "Automatyczna akceptacja komentarzy zalogowanych": "Automatic approval of comments by logged-in users",
        "Automatyczna akceptacja wszystkich komentarzy": "Automatic acceptance of all comments",
        "Automatyczna publikacja galerii": "Automatic publication of galleries",
        "Automatyczna publikacja wideo": "Automatic video publishing",
        "Automatyczne anulowanie zamówienia.": "Automatic order cancellation.",
        "Automatyczny": "Automatic",
        "Automatyczny przewodnik po treściach witryny dla narzędzi AI.": "Automatic guide to website content for AI tools.",
        "Autor": "Author",
        "Autor będzie powiązany z kontem w panelu.": "Author will be linked to an account in panel.",
        "Autor komentarza": "Comment author",
        "Autor nie może zostać usunięty, ponieważ jest przypisany do artykułów": "The author cannot be removed because he is assigned to articles",
        "Autor został dodany.": "The author added.",
        "Autor został usunięty.": "The author has been removed.",
        "Autor został zaktualizowany.": "The author has been updated.",
        "Autorzy": "Authors",
        "Autorzy spoza bazy użytkowników": "Authors outside the user base",
        "Baner został dodany.": "The banner has been added.",
        "Baner został zaktualizowany.": "The banner has been updated.",
        "Banery": "Banners",
        "Banner został usunięty.": "The banner has been removed.",
        "Barwa tekstu": "Text color",
        "Barwa tła": "Background color",
        "Baza dokumentów": "Document database",
        "Bez \"http(s)://\" i \"/\" na końcu.": "No \"http(s)://\" and \"/\" at the end.",
        "Bez autora": "No author",
        "Bez modułu": "No module",
        "Bez witryny": "No website",
        "Bezpieczeństwo": "Safety",
        "Bezpieczny adres URL": "Secure URL",
        "bieżąca": "Current",
        "Błąd 404": "404 error",
        "Błąd płatności": "Payment error",
        "Błąd renderowania bloku": "Block rendering error",
        "Blik": "BLIK payments",
        "blisko limitu": "near limit",
        "Blokada /api/*, reguły przełączników AI i adresy sitemapy są dodawane automatycznie. Własne wpisy są z nimi łączone; reguły Allow mogą zmienić zakres blokad.": "Blocking /api/*, AI switch rules, and sitemap addresses are added automatically. Custom entries are combined with them; Allow rules can change scope of blocks.",
        "Brak": "Lack",
        "Brak akcji w tej sesji.": "No actions in this session.",
        "Brak artykułów w czołówce.": "No featured articles.",
        "Brak czołówki": "No www page header",
        "Brak danych": "No data",
        "Brak danych do faktury.": "No invoice details.",
        "Brak dodanych plików": "No files added",
        "Brak dostępnej opublikowanej wersji tej aranżacji.": "No published version of this layout is available.",
        "Brak dostępnych typów aranżacji": "No layout types available",
        "Brak dostępnych typów widgetów.": "No widget types available.",
        "Brak etykiety": "No label",
        "Brak historii cen.": "No price history.",
        "Brak innych aranżacji zawierających tę sekcję.": "No other layouts containing this section.",
        "Brak kategorii": "No categories",
        "Brak kategorii nadrzędnej": "No parent category",
        "Brak kategorii.": "No categories.",
        "Brak komentarzy w tej zakładce.": "No comments in this tab.",
        "Brak listy regulaminów": "No list of regulations",
        "Brak modułu": "No module",
        "Brak odpowiedzi": "No answers",
        "Brak odrzuconych zgód": "No rejected consents",
        "Brak opinii": "No reviews",
        "Brak parametrów konfiguracji": "No configuration parameters",
        "Brak pasujących aranżacji": "No matching layouts",
        "Brak pasujących sekcji": "No matching sections",
        "Brak pasujących widżetów": "No matching widgets",
        "brak pól": "no fields",
        "Brak potwierdzenia": "No confirmation",
        "Brak powiązań": "No connection",
        "Brak powiązanych artykułów.": "No related articles.",
        "Brak pozycji.": "No items.",
        "Brak przypisanych regulaminów.": "No assigned terms and conditions.",
        "Brak regulaminów do zaakceptowania.": "No terms and conditions to approve.",
        "Brak sekcji": "No sections",
        "Brak sekcji szablonu": "No template sections",
        "Brak sitemap.": "No sitemap.",
        "Brak slajdów": "No slides",
        "Brak stron": "No pages",
        "Brak stron dostępnych dla wybranej witryny i języka.": "No pages available for selected site and language.",
        "Brak stron w katalogu": "No pages in catalog",
        "Brak strony nadrzędnej": "No parent page",
        "Brak uprawnień": "No privileges",
        "Brak uprawnień do edycji grupy banerów.": "No privileges to edit banner group.",
        "Brak uprawnień do usuwania linków wewnętrznych.": "No privileges to delete internal links.",
        "Brak uprawnień do usuwania subskrypcji.": "No privileges to delete subscriptions.",
        "Brak uprawnień do usuwania top tematów.": "No privileges to delete top topics.",
        "Brak użytkownika na liście oznacza, że jego imię lub nazwisko należy uzupełnić w dziale Użytkownicy.": "If a user is not on the list, their first or last name needs to be completed in Users.",
        "Brak widgetów w tym regionie.": "No widgets in this region.",
        "Brak widżetów pasujących do wyszukiwania.": "No widgets match your search.",
        "Brak widżetów tego typu": "No widgets of this type",
        "Brak wpisów do edycji": "No entries to edit",
        "Brak wybranych autorów": "No selected authors",
        "Brak wyrażonych zgód": "No consent given",
        "Brak zamówień.": "No orders.",
        "Brak zestawów spełniających kryteria.": "No sets match the criteria.",
        "Brak zgłoszeń": "No submissions",
        "brak zmian w polach": "no changes to fields",
        "Brakuje obszaru na główną treść strony, np. artykuł. Wybierz szablon z obszarem „Treść modułu” lub dodaj go w konfiguracji szablonu.": "There is no area for the main page content, such as an article. Select a template with a “Module content” area or add one in template settings.",
        "Browse files": "Browse files",
        "Browse links": "Browse links",
        "Cache": "Cache",
        "Cała zawartość jest projektowana w PageBuilderze. Strona nie korzysta z modułu ani aranżacji CMS.": "All content is designed in PageBuilder. Page does not use a CMS module or layout.",
        "Cel i zasięg": "Purpose and reach",
        "Cena": "Price",
        "Cena brutto": "Gross price",
        "Cena została wyłączona z historii.": "Price has been excluded from the story.",
        "Cennik": "Pricing",
        "CLS": "CLS",
        "CMS": "CMS",
        "Co godzinę": "Every hour",
        "Co miesiąc": "Every month",
        "Co rok": "Every year",
        "Co tydzień": "Every week",
        "Codziennie": "Every day",
        "Cofanie...": "Undoing...",
        "Cofnięto operację na widgetu": "Widget operation undone",
        "Cofnięto zmianę": "Change undone",
        "Cofnij": "Undo",
        "Cofnij ostatnią zmianę inline": "Undo last inline change",
        "Cykl życia zamówienia": "Order lifecycle",
        "Czas na slajd": "Time per slide",
        "Czas na stronie": "Time on page",
        "Czas po jakim zamówienie wygaśnie": "Time after which the order will expire",
        "Czas po jakim zamówienie zostanie anulowane": "Time after which the order will be cancelled",
        "Czas UTC": "UTC time",
        "Czas życia": "Lifetime",
        "Czekam na metryki wydajności z podglądu.": "Waiting for performance metrics from preview.",
        "Część zmiennych zostanie podstawiona dopiero przy renderowaniu.": "Some variables will only be substituted during rendering.",
        "Częstotliwość odświeżania": "Refresh rate",
        "Częstotliwość zmian (changefreq)": "Change frequency (changefreq)",
        "Czołówka": "Headline",
        "Czołówka została dodana.": "The lead has been added.",
        "Czołówka została usunięta.": "The lead has been removed.",
        "Czołówka została zaktualizowana.": "The lead has been updated.",
        "Czwartek": "Thursday",
        "Czy chcesz ją przywrócić?": "Do you want to bring it back?",
        "Czy na pewno chcesz usunąć tę stronę?": "Are you sure you want to delete this page?",
        "Czytać mogą tylko zalogowani użytkownicy": "Only logged-in users can read it",
        "Dalsza część artykułu przeznaczona jest dla osób z subskrypcją premium": "Rest of article is for premium subscribers",
        "Dalsze polecenie": "Further instruction",
        "Dane autoryzacyjne Google Analytics": "Google Analytics authentication data",
        "Dane developerskie skopiowane do schowka.": "Developer data copied to clipboard.",
        "Dane do faktury": "Invoice data",
        "Dane klienta": "Customer details",
        "Dane wpisu": "Entry data",
        "Dane wzoru": "Pattern data",
        "Data": "Date",
        "Data akceptacji": "Acceptance date",
        "Data automatycznej akceptacji": "Auto acceptance date",
        "Data dezaktywacji": "Deactivation date",
        "Data do": "Date to",
        "Data dodania": "Adding date",
        "Data i czas – 2026-09-04T14:30:00Z": "Date and time – 2026-09-04T14:30:00Z",
        "Data i godzina": "Date and hour",
        "Data informująca o terminie wejścia w życie tego regulaminu.": "The date informing about date of entry into force of these regulations.",
        "Data modyfikacji": "Modification date",
        "Data od": "Date from",
        "Data odrzucenia": "Rejection date",
        "Data opłacenia": "Date of payment",
        "Data publikacji": "Publication date",
        "Data publikacji regulaminu": "Terms publication date",
        "Data publikacji slajdera": "Slider publication date",
        "Data rezygnacji": "Date of resignation",
        "Data rozpoczęcia": "Start date",
        "Data wydania": "Release date",
        "Data wygaśnięcia": "Expiration date",
        "Data zakończenia": "End date",
        "Data zakończenia publikacji nie może być wcześniejsza, niż jej rozpoczęcie": "Publication end date cannot be earlier than its start date",
        "Data zapisania się": "Date of enrollment",
        "Data zgłoszenia": "Notification date",
        "Daty": "Dates",
        "Daty publikacji": "Publication dates",
        "Daty publikacji zostały zaktualizowane.": "The publication dates have been updated.",
        "Definicja szablonu": "Template definition",
        "Desktop": "Desktop",
        "Dev": "Dev",
        "Dezaktywuj": "Deactivate",
        "Diagnostyka": "Diagnostics",
        "Dla procesu zakupowego": "For the purchasing process",
        "Długość": "Length",
        "Długość mieści się w zalecanym limicie.": "Length is within recommended limit.",
        "Długość zależy od podstawionej wartości.": "Length depends on substituted value.",
        "dni": "days",
        "Dni": "Days",
        "Do odebrania w punkcie": "Available for pickup",
        "Do poziomu": "To level",
        "Docelowa strona": "Target page",
        "Dodaj": "Add",
        "Dodaj aranżację": "Add an arrangement",
        "Dodaj artykuł": "Add article",
        "Dodaj autora": "Add author",
        "Dodaj baner": "Add banner",
        "Dodaj czołówkę": "Add a headlamp",
        "Dodaj definicję szablonu, aby skonfigurować jego sekcje.": "Add a template definition to configure its sections.",
        "Dodaj dokument": "Add the document",
        "Dodaj element": "Add item",
        "Dodaj etykietę": "Add tag",
        "Dodaj galerię": "Add gallery",
        "Dodaj gazetkę": "Add newspaper",
        "Dodaj grupę": "Add group",
        "Dodaj katalog": "Add directory",
        "Dodaj kategorie": "Add category",
        "Dodaj kategorię": "Add category",
        "Dodaj konkretny przykład zastosowania": "Add a specific use case",
        "Dodaj link": "Add link",
        "Dodaj nofollow": "Add nofollow",
        "Dodaj nowa kategorię": "Add a new category",
        "Dodaj nową witrynę aby rozpocząć zarządzanie stronami.": "Add a new website to start managing your pages.",
        "Dodaj nowy katalog aby rozpocząć zarządzanie stronami.": "Add a new directory to start managing your pages.",
        "Dodaj nowy tag": "Add new tag",
        "Dodaj nowy widżet, podając jego nazwę poniżej.": "Add a new widget by entering its name below.",
        "Dodaj odpowiedź": "Add answer",
        "Dodaj opinię": "Add feedback",
        "Dodaj pierwszy slajd, aby uzupełnić obrazy i treść.": "Add first slide to fill in images and content.",
        "Dodaj plik": "Add a file",
        "Dodaj powiązany artykuł": "Add related article",
        "Dodaj powiązany rekord": "Add related record",
        "Dodaj powód": "Add reason",
        "Dodaj przekierowanie": "Add redirection",
        "Dodaj publikację": "Add publication",
        "Dodaj pytanie": "Add question",
        "Dodaj rotator": "Add rotator",
        "Dodaj sekcję": "Add section",
        "Dodaj sekcję z kolumnami – w aranżacjach redaktorzy umieszczą w nich widgety.": "Add a section with columns – editors will place widgets in them in layouts.",
        "Dodaj sekcję z kolumnami – w tych slotach redaktorzy będą umieszczać widgety w aranżacjach.": "Add a section with columns – editors will place widgets in these slots in layouts.",
        "Dodaj shortcode": "Add shortcode",
        "Dodaj ShortCode": "Add ShortCode",
        "Dodaj slajd": "Add slide",
        "Dodaj slajder": "Add slider",
        "Dodaj słowo": "Add word",
        "Dodaj stronę": "Add page",
        "Dodaj szablon": "Add template",
        "Dodaj treść": "Add content",
        "Dodaj tutaj": "Add here",
        "Dodaj typ": "Add type",
        "Dodaj typ aranżacji": "Add layout type",
        "Dodaj wideo": "Add video",
        "Dodaj widget do sekcji": "Add widget to section",
        "Dodaj widget tutaj": "Add widget here",
        "Dodaj widżet": "Add widget",
        "Dodaj witrynę": "Add website",
        "Dodaj wpis": "Add entry",
        "Dodaj wybrane": "Add selected",
        "Dodaj wzór": "Add pattern",
        "Dodaj zestaw": "Add set",
        "Dodane przez": "Added by",
        "Dodane przez moje zespoły": "Added by my teams",
        "Dodane przeze mnie": "Added by me",
        "Dodanie aktualności": "Add news",
        "Dodanie ankiety": "Add surveys",
        "Dodanie aranżacji": "Adding an arrangement",
        "Dodanie artykułu": "Add article",
        "Dodanie autora": "Addition of author",
        "Dodanie baneru": "Adding a banner",
        "Dodanie czołówki": "Adding a headlamp",
        "Dodanie dokumentu": "Addition of document",
        "Dodanie etykiety": "Add tag",
        "Dodanie galerii": "Adding a gallery",
        "Dodanie gazetki": "Adding a newspaper",
        "Dodanie grupy": "Adding a group",
        "Dodanie kategorii": "Add category",
        "Dodanie linku": "Add link",
        "Dodanie linku wewnętrznego": "Adding an internal link",
        "Dodanie pakietu": "Adding a package",
        "Dodanie poradnika": "Add guide",
        "Dodanie regulaminu": "Add regulations",
        "Dodanie rotatora": "Adding a rotator",
        "Dodanie slajdera": "Add slider",
        "Dodanie strony": "Add page",
        "Dodanie szablonu": "Add template",
        "Dodanie top tematu": "Adding a top topic",
        "Dodanie wideo": "Adding video",
        "Dodanie witryny": "Add website",
        "Dodanie wzoru": "Adding pattern",
        "Dodanie zestawu regulaminów": "Add set of regulations",
        "dodano": "added",
        "Dodano widget": "Widget added",
        "Dodano za dużo stron (maksymalnie %0).": "Too many pages added (maximum %0).",
        "Dodatkowe parametry w adresie URL": "Additional URL parameters",
        "Dodatkowe reguły robots.txt": "Additional robots.txt rules",
        "Dodawanie ankiety": "Adding poll",
        "Dodawanie dokumentu": "Adding document",
        "Dodawanie galerii": "Adding gallery",
        "Dodawanie gazetki": "Adding brochure",
        "Dodawanie linku": "Adding link",
        "Dodawanie pytań i odpowiedzi": "Adding questions and answers",
        "Dodawanie rotatora": "Adding carousel",
        "Dodawanie tylko po zalogowaniu": "Adding only when logged in",
        "Dodawanie wideo": "Adding video",
        "Dokąd prowadzi odnośnik i gdzie obowiązuje.": "Where the link goes and where it applies.",
        "Dokument": "Document",
        "Dokument nie jest jeszcze nigdzie opublikowany.": "The document has yet not been published anywhere.",
        "Dokument nie ma ustawionej daty publikacji.": "The document does not have a publication date set.",
        "Dokument został dodany.": "Document has been added.",
        "Dokument został usunięty.": "The document has been removed.",
        "Dokument został w międzyczasie zmieniony przez kogoś innego.": "Document was changed by someone else in the meantime.",
        "Dokument został w międzyczasie zmieniony przez kogoś innego. Nadpisanie zastąpi cudzą zmianę, a odświeżenie porzuci Twoją edycję i pokaże aktualne dane.": "Document has been changed by someone else in the meantime. Overwriting will replace their changes, while refreshing will discard your edits and show current data.",
        "Dokument został zaktualizowany.": "The document has been updated.",
        "Dokumenty": "Documents",
        "Dołącz stronę do pliku sitemap.xml": "Add the page to the sitemap file.xml",
        "domena witryny": "site domain",
        "Domyślna": "Default",
        "Domyślna stopka": "Default footer",
        "Domyślna strona dla wybranego modułu": "Default page for selected module",
        "Domyślna witryna": "Default site",
        "Domyślne": "Default",
        "Domyślne logo": "Default logo",
        "Domyślne ustawienie dla witryny": "Default site setting",
        "Domyślny": "Default",
        "Domyślny tytuł aktywnej strony": "Default title of the active page",
        "Dopasowanie": "Matching",
        "Dostarczone": "Delivered",
        "Dostawa": "Delivery",
        "Dostęp robotów AI": "AI robot access",
        "Dostępna wersja robocza": "Draft available",
        "Dostępne dla": "Available for",
        "Dostępne i opublikowane wersje językowe witryny.": "Available and published website language versions.",
        "Dostępne języki": "Available languages",
        "Dostępne moduły": "Available modules",
        "Dostępne sekcje": "Available sections",
        "Dostępne wersje językowe.": "Available language versions.",
        "Dostępne widgety zależą od witryny, języka i szablonu.": "Available widgets depend on website, language, and template.",
        "Dostępne widgety: {count}": "Available widgets: {count}",
        "Dostępne widżety": "Available widgets",
        "Dostępne wpisy: {count}": "Available posts: {count}",
        "Dostępne zmienne": "Available variables",
        "Dostępność": "Availability",
        "Dostosuj kolumny dla tego urządzenia": "Customize columns for this device",
        "Dotyczy": "Applies to",
        "Drugi klucz - md5": "Second key - md5",
        "Drugie powiadomienie": "Second notification",
        "Duplikuj": "Duplicate",
        "Duplikuj aranżację": "Duplicate layout",
        "Duplikuj blok": "Duplicate block",
        "Dynamiczny": "Dynamic",
        "Dzień tygodnia": "Day of the week",
        "e-commerce": "e-commerce",
        "E-mail": "E-mail",
        "Edito tworzy plik automatycznie na podstawie publicznych treści uwzględnionych w mapie witryny. Nie musisz przygotowywać ani wgrywać pliku.": "Edito automatically creates a file based on public content included in sitemap. You do not need to prepare or upload a file.",
        "Edycja": "Edit",
        "Edycja aktualności": "Edit news",
        "Edycja ankiety": "Edit survey",
        "Edycja aranżacji": "Edit arrangement",
        "Edycja artykułu": "Edit article",
        "Edycja autora": "Author's edit",
        "Edycja baneru": "Banner editing",
        "Edycja czołówki": "Headline Edition",
        "Edycja dokumentu": "Edit document",
        "Edycja etykiety": "Edit label",
        "Edycja galerii": "Gallery editing",
        "Edycja gazetki": "Newspaper edition",
        "Edycja grupy": "Group edit",
        "Edycja kategorii": "Edit category",
        "Edycja kategorii dokumentów": "Edit document category",
        "Edycja komentarza": "Edit comment",
        "Edycja linku": "Edit link",
        "Edycja linku wewnętrznego": "Edit internal link",
        "Edycja pakietu": "Editing the package",
        "Edycja poradnika": "Edit guide",
        "Edycja pytań i odpowiedzi": "Edit questions and answers",
        "Edycja pytania i odpowiedzi": "Edit question and answer",
        "Edycja regulaminu": "Edit regulations",
        "Edycja rotatora": "Edit rotator",
        "Edycja slajdera": "Edit slider",
        "Edycja strony": "Edit page",
        "Edycja szablonu": "Edit template",
        "Edycja top tematu": "Edit top topic",
        "Edycja ustawień": "Edit settings",
        "Edycja wideo": "Video editing",
        "Edycja witryny": "Edit site",
        "Edycja wzoru": "Edit template",
        "Edycja zestawu regulaminów": "Editi set of regulations",
        "Edytowano pole": "Field edited",
        "Edytuj": "Edit",
        "Edytuj adres e-mail": "Edit email address",
        "Edytuj aranżację": "Edit arrangement",
        "Edytuj aranżację alternatywną": "Edit alternative layout",
        "Edytuj autora": "Edit author",
        "Edytuj czołówkę": "Edit header",
        "Edytuj datę": "Edit date",
        "Edytuj etykietę": "Edit label",
        "Edytuj formularz": "Edit form",
        "Edytuj kategorię": "Edit category",
        "Edytuj kolor": "Edit color",
        "Edytuj kolumny sekcji": "Edit section columns",
        "Edytuj komentarz": "Edit comment",
        "Edytuj liczbę": "Edit number",
        "Edytuj link": "Edit link",
        "Edytuj menu": "Edit menu",
        "Edytuj obszar": "Edit area",
        "Edytuj oś czasu": "Edit timeline",
        "Edytuj plik": "Edit file",
        "Edytuj powiązania": "Edit associations",
        "Edytuj przekierowanie": "Edit redirect",
        "Edytuj pytanie": "Edit question",
        "Edytuj rotator": "Edit rotator",
        "Edytuj sekcję": "Edit section",
        "Edytuj shortcode": "Edit shortcode",
        "Edytuj slajder": "Edit slider",
        "Edytuj stronę": "Edit page",
        "Edytuj tekst": "Edit text",
        "Edytuj treść": "Edit content",
        "Edytuj widget": "Edit widget",
        "Edytuj wpis": "Edit post",
        "Edytuj wstawkę": "Edit insert",
        "Edytuj wybór": "Edit selection",
        "Edytuj wybraną ankietę.": "Edit selected survey.",
        "Edytuj zestaw": "Edit set",
        "Edytujesz sekcję {current} z {total}.": "You are editing section {current} of {total}.",
        "Eksport": "Export",
        "element": "item",
        "elementów": "items",
        "Elementy dostępne w aranżacjach tej witryny.": "Items available in layouts for this website.",
        "Elementy osi czasu": "Timeline items",
        "Email": "E-mail",
        "Email użytkownika": "User email",
        "Entuzjastyczny": "Enthusiastic",
        "EQL": "EQL",
        "etykieta": "label",
        "Etykieta": "Tag",
        "Etykieta została dodana.": "The label has been added.",
        "Etykieta została usunięta.": "The label has been removed.",
        "Etykieta została zaktualizowana.": "The label has been updated.",
        "Etykiety": "Tags",
        "Etykiety pól na stronie": "Field labels on page",
        "Facebook Admins": "Facebook Admins",
        "Facebook Application ID": "Facebook Application ID",
        "Favicona": "Favicon",
        "Film": "Film",
        "Film z YouTube": "YouTube video",
        "Filtr audytu": "Audit filter",
        "Filtry": "Filters",
        "Finalnie:": "Final result:",
        "Finalnie: pole będzie puste.": "Final result: field will be empty.",
        "Firma": "Company",
        "Folder został usunięty.": "The folder has been deleted.",
        "Forma płatności": "Form of payment",
        "Formalny": "Formal",
        "Format daty modyfikacji (lastmod)": "Modification date format (lastmod)",
        "Format pliku": "File format",
        "formularz": "form",
        "Formularz": "Modules / Contact form",
        "Formularz kontaktowy": "Contact form",
        "Formularz nie istnieje.": "Form does not exist.",
        "Formularz określający pola wypełniane przy wstawianiu shortcode.": "Form specifying fields to fill in when inserting a shortcode.",
        "Formularz wyświetlany pod artykułem": "Form displayed below article",
        "Francuski": "French",
        "Fraza": "Phrase",
        "Fraza podmieniana w treści na odnośnik.": "Phrase replaced with a link in content.",
        "Front nie odpowiedział w wymaganym czasie.": "Front end did not respond within required time.",
        "Front zwrócił błąd:": "Front end returned an error:",
        "Funkcje dostępne podczas tworzenia stron witryny.": "Features available when creating website pages.",
        "Galeria": "Gallery",
        "Galeria nie jest jeszcze nigdzie opublikowana.": "The gallery is not yet published anywhere.",
        "Galeria nie ma ustawionej daty publikacji.": "The gallery does not have a publication date set.",
        "Galeria zdjęć": "Photo gallery",
        "Galeria zdjęć premium": "Premium photo gallery",
        "Galeria została dodana.": "The gallery has been added.",
        "Galeria została usunięta.": "The gallery has been removed.",
        "Galeria została zaktualizowana.": "The gallery has been updated.",
        "Gazetka": "Newspaper",
        "Gazetka nie jest jeszcze nigdzie opublikowana.": "The newspaper is not yet published anywhere.",
        "Gazetka nie ma ustawionej daty publikacji.": "The newspaper does not have a set publication date.",
        "Gazetka została dodana.": "The newspaper has been added.",
        "Gazetka została usunięta.": "The newspaper has been removed.",
        "Gazetka została zaktualizowana.": "The newspaper has been updated.",
        "Generowanie": "Generating",
        "Generowanie sitemapów zostało zlecone. Może to potrwać kilka minut.": "Sitemap generation has been requested. This may take a few minutes.",
        "Generowanie stron gazetek...": "Generating newspaper pages...",
        "Generowanie stron gazetki nie jest aktywne.": "Generating newsletter pages is not active.",
        "Generowanie treści": "Content generation",
        "Generowanie trwa zbyt długo. Odśwież stronę, aby sprawdzić aktualny status.": "Generation is taking too long. Refresh page to check current status.",
        "Generuj": "Generate",
        "Generuj nowe sitemapy": "Generate new sitemaps",
        "Generuj ponownie": "Generate again",
        "Generuj strony gazetki": "Generate newspaper pages",
        "Generuj treść": "Generate content",
        "Generuj wszystkie metadane": "Generate all metadata",
        "Generuję treść…": "Generating content…",
        "gł.": "abbrev.",
        "głos": "vote",
        "głosów": "votes",
        "Główna": "Main",
        "Główny nagłówek widoczny na stronie artykułu.": "Main heading displayed on article page.",
        "godz.": "hrs.",
        "Godzina": "Time",
        "Google Maps": "Google Maps",
        "Goście nie mogą dodawać komentarzy. Dostęp do czytania określa osobne ustawienie.": "Guests cannot add comments. Access to reading is controlled by a separate setting.",
        "Goście nie mogą zgłaszać komentarzy do moderacji.": "Guests cannot submit comments for moderation.",
        "Gotowe": "Done",
        "Gotowe widgety: %0": "Ready-made widgets: %0",
        "Gotowe widżety": "Ready-made widgets",
        "Grafika wyświetlana jako okładka filmu.": "Image displayed as movie cover.",
        "Grafiki": "Images",
        "Granice widgetów na stronie": "Widget boundaries on page",
        "Grupa": "Group",
        "Grupa banerów już nie istnieje.": "Banner group no longer exists.",
        "Grupa banerów została dodana.": "The banner group has been added.",
        "Grupa banerów została usunięta.": "The banner group has been removed.",
        "Grupa banerów została zaktualizowana.": "The banner group has been updated.",
        "Grupy": "Groups",
        "Historia": "History",
        "Historia wersji będzie dostępna po zapisaniu artykułu.": "Version history will be available after saving article.",
        "Historia zmian ceny": "Price change history",
        "Historia zmian inline": "Inline change history",
        "i posiadających wymagane uprawnienia": "and having the required permissions",
        "Id": "Id",
        "ID": "ID",
        "id aktualnej rewizji": "current revision ID",
        "id pierwszej wersji": "first version ID",
        "Id punktu płatności - posId": "Id of the payment point - posId",
        "Id wpisu": "Entry ID",
        "Identyfikator aplikacji Meta powiązanej z witryną.": "Meta application ID associated with site.",
        "Identyfikator filmu z adresu YouTube, np. część po v=.": "Video ID from YouTube URL, e.g. part after v=.",
        "Identyfikator kontenera Google Tag Manager używanego w tej witrynie.": "Google Tag Manager container ID used on this site.",
        "Identyfikator OAuth używany do połączenia z PayU. Skopiuj client_id z konfiguracji punktu POS.": "OAuth ID used to connect to PayU. Copy client_id from POS point configuration.",
        "Identyfikator punktu płatności w PayU. Znajdziesz go w konfiguracji punktu POS w panelu PayU.": "PayU payment point ID. You can find it in POS point configuration in PayU panel.",
        "Identyfikator sekcji": "Section ID",
        "Identyfikator usługi Google Analytics": "Google Analytics service ID",
        "Identyfikator usługi Google Analytics, z której mają być pobierane statystyki.": "Google Analytics service ID to fetch statistics from.",
        "Ikona": "Icon",
        "Ikona pomagająca rozpoznać wzór podczas wyboru shortcode.": "Icon to help identify pattern when selecting shortcode.",
        "Ikona wyświetlana jest w postaci kwadratu.": "The icon is displayed in the form of a square.",
        "Ile dni przed zakończeniem subskrypcji autoodnawialnej rozpocznie się pobranie płatności.": "How many days before an auto-renewing subscription ends should payment collection begin.",
        "Ile razy system ponawia nieudaną płatność.": "How many times should system retry a failed payment.",
        "Ilość dni przed": "Number of days before",
        "Ilość kolumn podkategorii": "Number of subcategory columns",
        "Ilość powtórzeń po wystąpieniu błędu": "Number of retries after an error occurs",
        "Ilość publikacji: %0": "Number of posts: %0",
        "Ilość wybranych stron: %0": "Number of selected pages: %0",
        "Ilość wyświetlanych aktualności": "Number of news updates displayed",
        "Ilość wyświetlanych artykułów": "Number of articles displayed",
        "Ilość wyświetlanych tagów": "Number of tags displayed",
        "Ilość zaakceptowanych regulaminów: ": "Number of accepted terms and conditions: ",
        "Im konkretniejsze polecenie, tym lepszy efekt – podaj temat, długość i ton wypowiedzi.": "More specific instructions produce better results – provide a topic, length, and tone.",
        "Imię": "First name",
        "Imię i nazwisko / nazwa autora": "Author's first and last name / name",
        "Import": "Imports",
        "Indeksowanie strony": "Page indexing",
        "Informacja": "Information",
        "Informacja o ciasteczkach": "Information about cookies",
        "Informacje o komentarzu": "Comment information",
        "Informacje o zamówieniu": "Order information",
        "inline": "inline",
        "INP": "INP",
        "Inspekcja": "Inspection",
        "Integracje": "Integrations",
        "Interakcja użytkownika (Komenatrze, Like)": "User Interaction (Comenats, Like)",
        "ISBN": "ISBN",
        "Jak przetworzyć zaznaczony fragment?": "How should selected text be processed?",
        "jawne": "public",
        "Jedno zdanie widoczne przy artykułach": "One sentence displayed with articles",
        "Jeśli pole jest puste to wstawiana automatycznie.": "If the field is empty, the value is inserted automatically.",
        "Jest używana jako ekran logowania. Dla danego języka może istnieć tylko jedna.": "Used as login screen. Only one can exist for each language.",
        "Jesteś w drugim dialogu: dodawanie powiązanego rekordu.": "You are in second dialog: adding a related record.",
        "Jesteś w drugim dialogu: edycja formularza.": "You are in second dialog: editing a form.",
        "Jesteś w drugim dialogu: edycja wpisu.": "You are in second dialog: editing an entry.",
        "Język": "Language",
        "Język domyślny": "Default language",
        "Język i ton": "Language and tone",
        "Język regulaminu": "Terms language",
        "Języki": "Languages",
        "JSON szablonu": "Template JSON",
        "Kanał RSS:": "RSS feed:",
        "Karta": "Card",
        "Karta produktu": "Product card",
        "Katalog": "Directory",
        "Katalog główny": "Root directory",
        "Katalog i pozycja strony w strukturze witryny.": "Directory and page position in site structure.",
        "Katalog linków": "Links directory",
        "Katalog został utworzony.": "The directory has been created.",
        "Kategoria": "Category",
        "Kategoria linku": "Link category",
        "Kategoria nadrzędna": "Parent category",
        "Kategoria subskrypcji": "Subscription category",
        "Kategoria subskrypcji została dodana.": "The subscription category has been added.",
        "Kategoria subskrypcji została usunięta.": "The subscription category has been removed.",
        "Kategoria subskrypcji została zaktualizowana.": "The subscription category has been updated.",
        "Kategoria urządzenia": "Device category",
        "Kategoria zawierająca formularz dla tego wzoru.": "Category containing form for this pattern.",
        "Kategoria została dodana.": "The category has been added.",
        "Kategoria została usunięta.": "The category has been removed.",
        "Kategoria została zaktualizowana.": "The category has been updated.",
        "Kategorie": "Categories",
        "Kategorię": "Category",
        "Kategorie linków": "Link categories",
        "Kategorię można opublikować tylko na jednej stronie.": "A category can only be published on one page.",
        "Kategorie subskrypcji": "Subscription categories",
        "Każdy komentarz pojawia się od razu.": "Each comment appears immediately.",
        "Kiedy": "When",
        "Klienci": "Clients",
        "Klient": "Client",
        "Kliknij stronę w drzewie po lewej, aby edytować jej ustawienia i metadane.": "Click a page in tree on left to edit its settings and metadata.",
        "Kliknij wybraną sekcję. Naciśnij Esc, aby anulować.": "Click selected section. Press Esc to cancel.",
        "Kliknij Zapisz u góry strony, aby opublikować zmianę.": "Click Save at top of page to publish change.",
        "Klucz API wykorzystywany przez mapy Google w witrynie.": "API key used by Google Maps on site.",
        "Klucz OAuth używany razem z clientId do autoryzacji połączenia z PayU. Skopiuj client_secret z tego samego punktu POS.": "OAuth key used with clientId to authorize connection to PayU. Copy client_secret from same POS point.",
        "Klucz zgody Ipresso": "Ipresso consent key",
        "Kobieta": "Woman",
        "Kod / miasto": "Code / city",
        "Kod bannera (tutaj wklej kod HTML i JS)": "Banner code (paste HTML and JS code here)",
        "Kod Bing Webmaster": "Bing Webmaster Code",
        "Kod Google Webmaster": "Google Webmaster Code",
        "Kod GTM": "GTM code",
        "Kod HTML": "HTML code",
        "Kod weryfikacji witryny w Bing Webmaster Tools, bez całego znacznika HTML.": "Site verification code for Bing Webmaster Tools, without full HTML tag.",
        "Kod weryfikacji witryny w Google Search Console, bez całego znacznika HTML.": "Site verification code for Google Search Console, without full HTML tag.",
        "kolejność": "order",
        "Kolejność odpowiedzi": "Answer order",
        "Kolejność opinii": "Review order",
        "Kolejność pytań i odpowiedzi": "Question and answer order",
        "Kolejność pytań zmienisz przeciąganiem lub strzałkami": "Reorder questions by dragging or using arrows",
        "Kolejność sekcji": "Section order",
        "Kolejność zmienisz przeciąganiem": "Reorder by dragging",
        "Kolejność zmienisz przeciąganiem lub strzałkami": "Reorder by dragging or using arrows",
        "Kolor": "Color",
        "Kolor tekstu": "Text color",
        "Kolor tekstu komunikatu.": "Message text color.",
        "Kolor tła": "Background color",
        "Kolor tła komunikatu.": "Message background color.",
        "Kolumna {index}": "Column {index}",
        "Kolumna {index} (%)": "Column {index} (%)",
        "Kolumna {number}": "Column {number}",
        "Kolumny": "Columns",
        "Komentarz": "Comments",
        "Komentarz do wyłączenia ceny": "Comments on price exclusion",
        "Komentarze": "Comments",
        "Komentarze dłuższe nie zostaną zapisane.": "Longer comments won't be saved.",
        "Komentarze gości trafiają do moderacji.": "Guest comments are sent for moderation.",
        "Komentarze włączone": "Comments enabled",
        "Komentarze zawierające te słowa będą blokowane lub moderowane.": "Comments containing these words will be blocked or moderated.",
        "Komputer": "Computer",
        "Komunikat mailowy": "E-mail message",
        "Konfiguracja": "Settings",
        "Konfiguracja aranżacji jest niedostępna ponieważ nie podano definicji szablonu.": "The arrangement configuration is not available because no template definition is provided.",
        "Konfiguracja shortcode": "Shortcode configuration",
        "Konfiguracja szablonu": "Template configuration",
        "Konfiguracja widgetów jest niedostępna ponieważ nie podano definicji szablonu.": "Widget configuration is not available because no template definition is provided.",
        "Konfiguracja widgetu została zapisana.": "The widget configuration has been saved.",
        "Konfiguruj stronę": "Configure page",
        "Konflikt edycji": "Edit conflict",
        "Kontener": "Container",
        "Konto": "Account",
        "Konto jest aktywne od razu po rejestracji.": "Account is active immediately after registration.",
        "Konto publiczne": "Public account",
        "Kontynent": "Continent",
        "kopia": "copy",
        "Kopiuj": "Copy",
        "Kopiuj adres": "Copy address",
        "Kopiuj do witryny": "Copy to site",
        "Kopiuj link": "Copy link",
        "Kopiuj path": "Copy path",
        "Kopiuj sekcję do aranżacji": "Copy section to layout",
        "Kopiuj widget": "Copy widget",
        "Kopiuj widżet do witryny": "Copy widget to site",
        "Kopiuj zmienną": "Copy variable",
        "Korzysta wyłącznie z ustawień z zakładki Podstawowe.": "Uses settings from Basic tab only.",
        "Koszyk": "Shopping cart",
        "Kraj": "Country",
        "Kreator stron": "Page builder",
        "Krótki identyfikator wzoru używany w systemie.": "Short pattern identifier used in system.",
        "Krótki opis": "Short description",
        "Krótki opis widoczny na listingu linków": "Short description displayed in link listing",
        "Krótki tytuł": "Short title",
        "Krótkie wprowadzenie przed główną treścią artykułu.": "Short introduction before main article content.",
        "krytyczne": "critical",
        "Krytyczne": "Critical",
        "Książka": "Book",
        "Kto może korzystać z systemu komentarzy.": "Who can use comment system.",
        "Kurier": "Courier",
        "Ładowanie edytora...": "Loading editor...",
        "Ładowanie elementów...": "Loading elements...",
        "Ładowanie podglądu...": "Loading preview...",
        "Ładowanie pól...": "Loading fields...",
        "Ładowanie treści...": "Loading content...",
        "Ładowanie zgłoszeń…": "Loading submissions…",
        "Ładuję opublikowaną wersję...": "Loading published version...",
        "Ładuję wersję roboczą...": "Loading draft...",
        "LCP": "LCP",
        "Liczba": "Number",
        "Liczba ankiet": "Number of surveys",
        "Liczba artykułów": "Number of articles",
        "Liczba kolumn": "Number of columns",
        "Liczba kolumn w wierszu": "Number of columns in row",
        "Liczba opinii: {count}. Kolejność zmienisz przeciąganiem lub strzałkami.": "Number of reviews: {count}. Change order by dragging or using arrows.",
        "Liczba ponowień płatności": "Number of payment retries",
        "Liczba slajdów widoczna dla użytkownika nie może być większa od liczby slajdów dodanych w panelu.": "The number of slides visible to the user cannot be greater than the number of slides added in the panel.",
        "Liczba stron głównego poziomu: {count}": "Number of top-level pages: {count}",
        "Liczba widżetów: {count}": "Number of widgets: {count}",
        "Liczba wyników": "Number of results",
        "Liczba wyświetlanych najnowszych elementów": "Number of recent elements displayed",
        "Liczba wyświetlanych slajdów": "Number of slides displayed",
        "Liczba wyświetleń": "Number of displays",
        "Liczba zamówień": "Number of orders",
        "Liczba znaków:": "Number of characters:",
        "Like do komentarzy mogą dodawać tylko zalogowani użytkownicy": "Like to comments can only be added by logged-in users",
        "Limit zgłoszeń": "Request limit",
        "Limity": "Limits",
        "Limity treści": "Content limits",
        "Linia ciągła": "Solid line",
        "Linia falująca": "Wavy line",
        "Linia kreskowana": "Dashed line",
        "Linia kropkowana": "Dotted line",
        "Link": "Link",
        "Link do strony": "Website link",
        "Link do widgetu skopiowany do schowka.": "Widget link copied to clipboard.",
        "Link do YouTube, Vimeo lub pliku mp4.": "YouTube, Vimeo, or mp4 file link.",
        "Link może prowadzić do pliku z repozytorium albo do zewnętrznego serwisu": "Link can point to a file in repository or an external service",
        "Link obszaru": "Area link",
        "Link prowadzi do pliku z repozytorium.": "Link points to a file in repository.",
        "Link prowadzi do zewnętrznego adresu.": "Link points to an external address.",
        "Link wewnętrzny": "Internal link",
        "Link wewnętrzny został dodany.": "The internal link has been added.",
        "Link wewnętrzny został usunięty.": "The internal link has been removed.",
        "Link wewnętrzny został zaktualizowany.": "The internal link has been updated.",
        "Link wygasł": "Link expired",
        "Link z serwisu": "Link from the site",
        "Link zewnętrzny": "External link",
        "Link został dodany.": "Link has been added.",
        "Link został usunięty.": "The link has been removed.",
        "Link został zaktualizowany.": "The link has been updated.",
        "Linki wewnętrzne": "Internal links",
        "Linki wewnętrzne zostały pomyślnie połączone.": "The internal links have been successfully connected.",
        "Lista": "List",
        "Lista artykułów": "List of articles",
        "Lista banerów": "List of banners",
        "Lista komentarzy": "Comments list",
        "Lista linków": "Links list",
        "Lista publikacji": "Publication list",
        "Lista regulaminów": "Regulation list",
        "Lista wyświetlana użytkownikowi przy zgłaszaniu.": "List displayed to user when submitting a report.",
        "Live Design": "Live Design",
        "Live design (beta)": "Live design (beta)",
        "llms.txt to rozwiązanie eksperymentalne": "llms.txt is an experimental solution",
        "Logo": "Logo",
        "Logo używane w wiadomościach tej witryny. Jeśli nie wybierzesz pliku, zostanie użyte domyślne logo systemu.": "Logo used in messages from this site. If you don't select a file, system default logo will be used.",
        "Logowanie": "Login",
        "Lp.": "No.",
        "Maksymalna ilość stron": "Maximum number of pages",
        "Maksymalna liczba najnowszych elementów pokazywanych na liście.": "Maximum number of latest items displayed in list.",
        "Maksymalna liczba pozycji w kanale": "Maximum number of items in feed",
        "Maksymalna liczba znaków dla niezalogowanych": "Maximum number of characters for logged-out users",
        "Maksymalna liczba znaków dla zalogowanych": "Maximum number of characters for logged-in users",
        "Maksymalna szerokość strony to 1410": "The maximum page width is 1410",
        "Maksymalna wysokość strony to 1080": "The maximum page height is 1080",
        "Mapowanie pól modułów Studio (JSON)": "Studio module field mapping (JSON)",
        "Marketing": "Marketing",
        "Masz niezapisane zmiany. Przejść bez zapisywania?": "You have unsaved changes. Leave without saving?",
        "Materiał wideo dołączony do wpisu": "Video attached to post",
        "Menu widgetu": "Widget menu",
        "Metadane": "Metadata",
        "Metryka": "Metric",
        "Mężczyzna": "Man",
        "Miasto": "City",
        "Miejsce ankiety": "Survey location",
        "Miejsce artykułu w strukturze serwisu": "Article location in site structure",
        "Miejsce otwarcia odnośnika (atrybut target), np. _blank dla nowej karty.": "Where to open link (target attribute), e.g. _blank for a new tab.",
        "Miejsce powiązanych artykułów": "Related articles location",
        "Miesiące": "Months",
        "Miniatura wyświetlana przed odtworzeniem": "Thumbnail displayed before playback",
        "Minimalna szerokość strony to 370": "The minimum page width is 370",
        "Minimalna wysokość strony to 500": "The minimum page height is 500",
        "Mobile": "Mobile",
        "Moduł": "Module",
        "Moduł dynamiczny": "Dynamic module",
        "Moduł konfigurowalny": "Configurable module",
        "Moduł nie wskazuje formularza dla sekcji tego widgetu.": "Module does not specify a form for this widget section.",
        "Moduł Studio zawierający formularz do wyświetlenia.": "Studio module containing form to display.",
        "Moduły": "Modules",
        "Moduły wyszukiwarki": "Search engine modules",
        "Możesz zacząć od:": "You can start with:",
        "Można ich używać we wszystkich polach tekstowych.": "They can be used in all text fields.",
        "Multimedia": "Multimedia",
        "Multimedia premium": "Premium multimedia",
        "Multimedia przypisane do artykułu": "Media assigned to article",
        "Na ile dni po zakończeniu subskrypcji wysłać powiadomienie.": "How many days after subscription ends to send notification.",
        "Na ile dni przed końcem subskrypcji wysłać przypomnienie.": "How many days before subscription ends to send reminder.",
        "Nabywca": "Buyer",
        "Naciśnij enter aby usunąć": "Press enter to delete",
        "Naciśnij enter aby wybrać": "Press enter to select",
        "Nadaj banerowi nazwę, wybierz grupę i określ adres docelowy.": "Name banner, select a group, and specify destination address.",
        "Nadaj sekcji czytelną nazwę używaną podczas edycji aranżacji.": "Give section a clear name used when editing layout.",
        "Nadpisz": "Overwrite",
        "Nagłówek widgetu widoczny dla odwiedzających stronę.": "Widget heading visible to site visitors.",
        "Najczęstszy wybór. Wyświetla dane z wybranego modułu, np. Aktualności, Kontakt lub Reklamacje. Wymaga modułu i aranżacji.": "Most common choice. Displays data from selected module, e.g. News, Contact, or Complaints. Requires a module and layout.",
        "Najedź na widget albo pole w podglądzie.": "Hover over a widget or field in preview.",
        "Najlepiej wybrać logo w formacie SVG — pozostaje ostre w każdym rozmiarze i dobrze wygląda na ekranach o wysokiej rozdzielczości.": "SVG logo is best — it stays sharp at any size and looks good on high-resolution screens.",
        "Najniższa cena z 30 dni przed obniżką": "Lowest price in 30 days before discount",
        "Najniższy": "Lowest",
        "Najnowsza wersja": "Latest version",
        "Najpierw dodaj stronę do gazetki.": "First, add the site to the newspaper.",
        "Najpierw wybierz typ aranżacji": "First select layout type",
        "Najpierw zapisz aranżację.": "Save layout first.",
        "Najpopularniejsze strony": "Most popular pages",
        "Najwięcej czasu spędzone na stronach": "Most time spent on pages",
        "Najwyższy": "Highest",
        "Napisz krótki lead na podstawie fragmentu": "Write a short lead based on excerpt",
        "Napisz wstęp do artykułu o wdrożeniu nowego portalu": "Write an introduction to an article about launching a new portal",
        "Narzędzia": "Tools",
        "Narzędzia podglądu": "Preview tools",
        "Następne pole": "Next field",
        "Nazwa": "Name",
        "Nazwa adresu": "Address name",
        "Nazwa aktywnej strony": "Active page name",
        "Nazwa aranżacji": "Arrangement name",
        "Nazwa autora": "Author name",
        "Nazwa czołówki": "Headlamp name",
        "Nazwa etapu": "Stage name",
        "Nazwa etykiety": "Label name",
        "Nazwa grupy": "Group name",
        "Nazwa i adres strony w witrynie.": "Page name and address on site.",
        "Nazwa katalogu": "Directory name",
        "Nazwa kategorii": "Category name",
        "Nazwa Kategorii": "Category Name",
        "Nazwa linku": "Link name",
        "Nazwa nowej kategorii": "New category name",
        "Nazwa obiektu": "Object name",
        "Nazwa pakietu": "Package name",
        "Nazwa płyty": "Disc name",
        "Nazwa rotatora": "Rotator name",
        "Nazwa sekcji": "Section name",
        "Nazwa shortcode": "Shortcode name",
        "Nazwa slajdera": "Slider name",
        "Nazwa slajdu": "Slide name",
        "Nazwa strony": "Page name",
        "Nazwa szablonu": "Template name",
        "Nazwa typu aranżacji": "Layout type name",
        "Nazwa ułatwia rozpoznanie aranżacji przy przypisywaniu jej do strony.": "Name helps identify layout when assigning it to a page.",
        "Nazwa w panelu": "Name in panel",
        "Nazwa wewnętrzna": "Internal name",
        "Nazwa widoczna na liście wzorów. Powinna jasno wskazywać przeznaczenie shortcode.": "Name displayed in template list. It should clearly indicate purpose of shortcode.",
        "Nazwa widoczna na stronie i w panelu oraz miejsce w drzewie": "Name displayed on page and in panel, and location in tree",
        "Nazwa widoczna wyłącznie w panelu administracyjnym.": "Name displayed only in admin panel.",
        "Nazwa widżetu": "Widget name",
        "Nazwa witryny": "Site name",
        "Nazwa wyświetlana": "Display name",
        "Nazwa zduplikowanej aranżacji": "Name of duplicated layout",
        "Nazwa, domena i szablon graficzny witryny.": "Website name, domain, and visual template.",
        "Nazwa, opis i przypisanie linku": "Name, description, and link assignment",
        "Nazwa, oznaczenie i ikona shortcode.": "Shortcode name, label, and icon.",
        "Nazwisko": "Last name",
        "Neutralny": "Neutral",
        "Nic nie publikuje się bez zatwierdzenia.": "Nothing is published without approval.",
        "Nie": "No",
        "Nie dodano żadnego autora.": "No author has been added.",
        "Nie ma jeszcze żadnych rekordów": "There are no records yet",
        "Nie ma własnej treści. Kieruje do wybranej strony tej samej witryny; można dodać parametry URL.": "Has no content of its own. Links to a selected page on the same website; URL parameters can be added.",
        "Nie ma własnej treści. Kieruje pod podany pełny adres URL i może otworzyć go w nowym oknie.": "Has no content of its own. Links to the specified full URL and can open it in a new window.",
        "Nie można już edytować tego linku wewnętrznego, ponieważ jest on aktualnie używany.": "This internal link can no longer be edited, as it is currently in use.",
        "Nie można usunąć zaznaczonych autorów, ponieważ co najmniej jeden z nich jest przypisany do artykułów.": "Selected authors cannot be deleted because at least one of them is assigned to articles.",
        "Nie można uzupełnić danych linku. Otwórz okno linku ponownie.": "Link details could not be completed. Reopen link window.",
        "Nie pokazuj krótkiego opisu strony w wynikach wyszukiwania (NoSnippet)": "Do not show a short description of the page in search results (NoSnippet)",
        "Nie pokazuj linku do archiwum strony (NoArchive)": "Do not show a link to the archive of the page (NoArchive)",
        "Nie pokazuj strony jako źródła grafiki w wynikach wyszukiwania (NoImageIndex)": "Do not show the page as an image source in search results (NoImageIndex)",
        "Nie pomocna": "Not helpful",
        "Nie posiadasz uprawnień do edycji tego artykułu.": "You do not have permission to edit this article.",
        "Nie udało się dodać widgetu do aranżacji.": "Could not add widget to layout.",
        "Nie udało się odświeżyć listy zestawów. Spróbuj ponownie.": "Could not refresh set list. Try again.",
        "Nie udało się otworzyć dodawania powiązanego rekordu.": "Could not open form to add a related record.",
        "Nie udało się otworzyć edycji formularza.": "Could not open form editor.",
        "Nie udało się otworzyć edycji powiązanego rekordu.": "Could not open form to edit related record.",
        "Nie udało się otworzyć formularza": "Could not open form",
        "Nie udało się otworzyć podglądu aranżacji.": "Could not open layout preview.",
        "Nie udało się oznaczyć zamówienia jako opłacone.": "Could not mark order as paid.",
        "Nie udało się pobrać adresu strony.": "Could not retrieve page address.",
        "Nie udało się pobrać aranżacji.": "Could not retrieve layout.",
        "Nie udało się pobrać dostępnych aranżacji.": "Could not retrieve available layouts.",
        "Nie udało się pobrać listy aranżacji": "Failed to download the arrangement list",
        "Nie udało się pobrać listy etykiet": "Failed to download label list",
        "Nie udało się pobrać listy kategorii": "Failed to download category list",
        "Nie udało się pobrać listy modułów": "Failed to download module list",
        "Nie udało się pobrać listy regulaminów": "Failed to download the list of regulations",
        "Nie udało się pobrać listy stron": "Failed to download the pages list",
        "Nie udało się pobrać listy witryn.": "Could not retrieve website list.",
        "Nie udało się pobrać pakietu.": "Could not retrieve package.",
        "Nie udało się pobrać pełnej listy zestawów.": "Could not retrieve complete set list.",
        "Nie udało się pobrać powiązanych wpisów dla tego widgetu.": "Could not retrieve related entries for this widget.",
        "Nie udało się pobrać treści.": "Could not retrieve content.",
        "Nie udało się pobrać ustawień wpisu dla tego widgetu.": "Could not retrieve entry settings for this widget.",
        "Nie udało się pobrać witryn.": "Could not retrieve websites.",
        "Nie udało się pobrać wybranych treści.": "Could not retrieve selected content.",
        "Nie udało się pobrać wyników ankiety. Spróbuj ponownie.": "Could not retrieve survey results. Try again.",
        "Nie udało się rozpoznać endpointu schemy formularza.": "Could not identify form schema endpoint.",
        "Nie udało się skopiować adresu.": "Could not copy address.",
        "Nie udało się skopiować do schowka.": "Could not copy to clipboard.",
        "Nie udało się skopiować widgetu.": "Could not copy widget.",
        "Nie udało się ustalić powiązanego rekordu.": "Could not identify related record.",
        "Nie udało się ustalić źródła powiązanego rekordu.": "Could not identify source of related record.",
        "Nie udało się ustalić źródła powiązanych rekordów.": "Could not identify source of related records.",
        "Nie udało się ustawić aranżacji domyślnej": "Could not set default layout",
        "Nie udało się wczytać danych klienta.": "Could not load customer data.",
        "Nie udało się wczytać grupy banerów.": "Could not load banner group.",
        "Nie udało się wczytać kanałów RSS": "Could not load RSS feeds",
        "Nie udało się wczytać klientów.": "Could not load customers.",
        "Nie udało się wczytać komentarzy.": "Could not load comments.",
        "Nie udało się wczytać przekierowań.": "Could not load redirects.",
        "Nie udało się wczytać sitemap. Spróbuj ponownie.": "Could not load sitemap. Try again.",
        "Nie udało się wczytać szablonów.": "Could not load templates.",
        "Nie udało się wczytać ustawień": "Could not load settings",
        "Nie udało się wczytać ustawień komentarzy.": "Could not load comment settings.",
        "Nie udało się wczytać ustawień RSS": "Could not load RSS settings",
        "Nie udało się wczytać ustawień RSS. Spróbuj ponownie.": "Could not load RSS settings. Try again.",
        "Nie udało się wczytać ustawień sitemap.": "Could not load sitemap settings.",
        "Nie udało się wczytać ustawień witryny.": "Could not load website settings.",
        "Nie udało się wczytać widgetu.": "Could not load widget.",
        "Nie udało się wczytać witryn.": "Could not load websites.",
        "Nie udało się wczytać wszystkich danych kategorii.": "Could not load all category data.",
        "Nie udało się wczytać wzorów shortcode.": "Could not load shortcode templates.",
        "Nie udało się wczytać wzoru shortcode.": "Could not load shortcode template.",
        "Nie udało się wczytać zamówień.": "Could not load orders.",
        "Nie udało się wczytać zamówienia.": "Could not load order.",
        "Nie udało się wczytać zgłoszeń": "Could not load tickets",
        "Nie udało się wczytać zgłoszeń. Spróbuj ponownie.": "Could not load tickets. Try again.",
        "Nie udało się wczytać zgód": "Could not load consents",
        "Nie udało się wyeksportować przekierowań.": "Could not export redirects.",
        "Nie udało się wygenerować stron gazetki.": "Could not generate newsletter pages.",
        "Nie udało się zaimportować przekierowań.": "Could not import redirects.",
        "Nie udało się zaktualizować wybranych aranżacji.": "Could not update selected layouts.",
        "Nie udało się załadować podglądu.": "Could not load preview.",
        "Nie udało się zapisać grupy banerów.": "Could not save banner group.",
        "Nie udało się zapisać ustawień. Sprawdź wartości i spróbuj ponownie.": "Could not save settings. Check values and try again.",
        "Nie udało się zapisać zmiany.": "Could not save change.",
        "Nie udało się zduplikować widgetu.": "Could not duplicate widget.",
        "Nie udało się zlecić generowania sitemap.": "Could not request sitemap generation.",
        "Nie wybrano authora.": "No author has been selected.",
        "Nie wybrano autora.": "No author selected.",
        "Nie wybrano jeszcze żadnego regulaminu. Wyszukaj regulamin powyżej i dodaj go do zestawu.": "No terms and conditions have been selected yet. Search for terms and conditions above and add them to set.",
        "Nie wybrano strony": "No page has been selected",
        "Nie wybrano żadnej kategorii": "No category was selected",
        "Nie wybrano żadnej strony.": "No page selected.",
        "Nie zdefiniowano żadnych sekcji.": "No sections are defined.",
        "Nie znaleziono edytowalnych pól w aktualnym podglądzie.": "No editable fields found in current preview.",
        "Nie znaleziono opublikowanej aranżacji.": "No published layout found.",
        "Nie znaleziono problemów.": "No issues found.",
        "Nie znaleziono widocznego elementu tego pola w aktualnym DOM podglądu.": "No visible element for this field found in current preview DOM.",
        "Nie znaleziono żadnych folderów.": "No folders were found.",
        "Nie związana": "Not linked",
        "Nieaktywna": "Inactive",
        "Nieaktywne": "Inactive",
        "Nieaktywny": "Inactive",
        "Niedostępny widżet może być wyłączony dla witryny lub już użyty jako unikalny element.": "Unavailable widget may be disabled for website or already used as a unique element.",
        "Niedozwolone słowa": "Unpermitted words",
        "Niedziela": "Sunday",
        "Nieformalny": "Informal",
        "niejednoznaczne": "ambiguous",
        "Niejednoznaczne": "Ambiguous",
        "Niemiecki": "German",
        "Nieobsługiwane pole edycji inline.": "Inline editing field not supported.",
        "Nieopłacone": "Unpaid",
        "Niepotwierdzona": "Unconfirmed",
        "Niestandardowy adres": "Non-standard address",
        "Niestandardowy adres strony": "Non-standard page address",
        "Niestandardowy nagłówek": "Custom header",
        "Nieudana próba doręczenia": "Failed delivery attempt",
        "Niezapisane zmiany:": "Unsaved changes:",
        "Nieznany status": "Unknown status",
        "Nigdy": "Never",
        "NIP": "Tax ID Number",
        "Niski": "Low",
        "Niżej": "Below",
        "Nofollow": "Nofollow",
        "Nowa": "New",
        "Nowa aktualność": "New update",
        "Nowa aranżacja": "New layout",
        "Nowa cena brutto": "New gross price",
        "Nowa cena do": "New price to",
        "Nowa cena od": "The new price from",
        "Nowa cena zacznie obowiązywać w podanym okresie.": "New price will apply during the specified period.",
        "Nowa kategoria": "New category",
        "Nowe pytanie": "New question",
        "Nowy artykuł": "New article",
        "Nowy autor": "New author",
        "Nowy widżet": "New widget",
        "np. _blank": "e.g. _blank",
        "np. 7": "e.g. 7",
        "np. Banner e-commerce": "e.g. E-commerce banner",
        "np. Czołówka Technologia": "e.g. Technology header",
        "np. E-commerce": "e.g. E-commerce",
        "np. pim": "e.g. pim",
        "np. pl-PL": "i.e., pl-PL",
        "np. poradnik": "e.g. guide",
        "np. Poradniki": "e.g. Guides",
        "np. Spam": "e.g. Spam",
        "np. Trwają prace serwisowe": "e.g. Maintenance in progress",
        "np. wyrażenie": "e.g. expression",
        "np. Zenon Mącugowski": "e.g. Zenon Mącugowski",
        "Numer": "Number",
        "Numer aktywnej strony": "Active page number",
        "Numer telefonu": "Phone number",
        "Obraz": "Image",
        "Obrazy bez wymiarów": "Images without dimensions",
        "Obrazy: automatycznie": "Images: automatic",
        "Obrazy: zawsze leniwie": "Images: always lazy",
        "Obrazy: zawsze natychmiast": "Images: always eager",
        "Obsługiwane są wyłącznie linki wewnętrzne": "Only internal links are supported",
        "Obszary aktywne": "Active areas",
        "Ochrona przed spamem": "Spam protection",
        "Oczekujące": "Pending",
        "Oczekujący na akceptację": "Awaiting approval",
        "Oczekuje na akceptację": "Awaiting approval",
        "Oczekuje na płatność": "Awaiting payment",
        "Oczekuje na potwierdzenie": "Awaiting confirmation",
        "Oczekuje na weryfikację": "Awaiting verification",
        "Oczekuje na wysyłkę": "Awaiting dispatch",
        "Oczekuje na zatwierdzenie": "Awaiting approval",
        "Od 1 do 50 najnowszych pozycji w każdym kanale RSS. Ustawienie dotyczy wszystkich witryn.": "From 1 to 50 latest items in each RSS feed. Setting applies to all sites.",
        "Od poziomu": "From level",
        "Odczyt tylko po zalogowaniu": "Read only when logged in",
        "Odebrane w punkcie": "Collected at pickup point",
        "Odepnij": "Unpin",
        "Odepnij od widżetu": "Unpin from widget",
        "Odnośnik": "Link",
        "Odnośnik do informacji o plikach cookies.": "Link to cookie information.",
        "Odnośnik do informacji o przetwarzaniu danych osobowych.": "Link to personal data processing information.",
        "Odnośnik do innej strony w serwisie": "Link to another page on site",
        "Odnośnik do strony w serwisie": "Link to a page on site",
        "Odnośnik do zewnętrznego adresu": "Link to an external address",
        "Odnośnik URL": "URL reference",
        "Odnośniki": "Links",
        "Odpięto dev details": "Unpinned dev details",
        "Odpowiedź": "Answer",
        "Odpowiedź {number}": "Answer {number}",
        "Odpowiedzi": "Responses",
        "Odrzuć": "Reject",
        "Odrzuć zmiany": "Discard changes",
        "Odrzucone": "Rejected",
        "Odrzucone zgody": "Rejected consents",
        "Odrzucony po zgłoszeniach": "Rejected after requests",
        "Odśwież": "Refresh",
        "Odśwież podgląd": "Refresh preview",
        "Odśwież wybór witryny i spróbuj ponownie.": "Refresh site selection and try again.",
        "Odświeżam podgląd formularza...": "Refreshing form preview...",
        "Odświeżam podgląd po dodaniu treści...": "Refreshing preview after adding content...",
        "Odświeżam podgląd...": "Refreshing preview...",
        "Odświeżono": "Refreshed",
        "Odświeżono schemę formularza": "Form schema refreshed",
        "Odznacz wszystkie": "Unselect all",
        "Ogólny": "General",
        "Ograniczenia długości komentarzy.": "Comment length limits.",
        "Okładka": "Cover",
        "Okładka do wideo premium": "Coverage for premium video",
        "Okładka oraz pliki PDF źródłowy i do pobrania.": "Cover and source and downloadable PDF files.",
        "Okres, w którym temat jest widoczny.": "Period during which topic is visible.",
        "Określ dostępność witryny oraz sposób dostępu do jej treści.": "Set site availability and how its content can be accessed.",
        "Określ zasady odkrywania treści i ich użycia przez dostawców AI.": "Set rules for content discovery and use by AI providers.",
        "Określ, jak aktywowane są konta zakładane przez rejestrację.": "Set how accounts created through registration are activated.",
        "Określ, kto może wyświetlić stronę.": "Set who can view page.",
        "Określa z której strony do ścieżki mają być dodawane kolejne pozycje.": "Specifies where you want to add additional items to the path.",
        "Określa, od kiedy komunikat ma być widoczny na stronie.": "Specifies when message becomes visible on page.",
        "Opcje linku": "Link options",
        "Opcje modułu przypisanego do tej strony.": "Options for module assigned to this page.",
        "Opcjonalne zdjęcie używane jako tło treści.": "Optional image used as content background.",
        "Open Graph": "Open Graph",
        "Operator płatności": "Payment operator",
        "Opinia": "Opinion",
        "Opinia autora": "Author's opinion",
        "Opinie": "Reviews",
        "Opis": "Description",
        "Opis przerwy technicznej": "Description of the technical break",
        "Opis sekcji": "Section description",
        "Opis witryny": "Site description",
        "Opis wyświetlany pod odtwarzaczem": "Description displayed below player",
        "Opisz, co mam napisać": "Describe what you want me to write",
        "Opłacone": "Paid",
        "Opublikował": "Published by",
        "Opublikowana": "Published",
        "Opublikowane": "Published",
        "Opublikowane języki": "Published languages",
        "Opublikowane wersje językowe.": "Published language versions.",
        "Opublikowany na stronach": "Published on pages",
        "Opublikuj": "Publish",
        "Opublikuj autora": "Publish author",
        "Origin formularza": "Form origin",
        "Oś czasu": "Timeline",
        "Osobne warianty dla różnych szerokości ekranu.": "Separate variants for different screen widths.",
        "Osoby podpisane pod artykułem": "People credited on article",
        "Ostatni miesiąc": "Last month",
        "Ostatni rok": "Last year",
        "Ostatni tydzień": "Last week",
        "Ostatnia aktualizacja:": "Last updated:",
        "Ostrzeżenia": "Warnings",
        "ostrzeżenie": "warning",
        "Otwiera się pod głównym adresem witryny. Dla danego języka może istnieć tylko jedna.": "Opens under main site address. Only one can exist for a given language.",
        "Otwieraj w nowym oknie": "Open in new window",
        "Otwórz edytor": "Open editor",
        "Otwórz podgląd llms.txt": "Open llms.txt preview",
        "Otwórz podgląd llms.txt i sprawdź opublikowaną zawartość.": "Open llms.txt preview and check published content.",
        "Otwórz podgląd robots.txt": "Open robots.txt preview",
        "Otwórz stronę w nowym oknie": "Open the page in a new window",
        "Otwórz w nowej karcie": "Open in new tab",
        "Otworzono dodawanie wpisu": "Entry creation opened",
        "Otworzono edytor wpisu": "Entry editor opened",
        "Otworzono formularz": "Form opened",
        "Oznacz jako opłacone": "Mark as paid",
        "Oznacza artykuł jako materiał sponsorowany.": "Marks article as sponsored content.",
        "Oznacza artykuł jako opinię autora.": "Marks article as author's opinion.",
        "Oznacza tę witrynę jako główną w systemie.": "Marks this site as primary in system.",
        "Oznacza treść jako dostępną w ramach premium.": "Marks content as available with premium access.",
        "Pakiet": "Package",
        "Pakiet aktywny": "Active package",
        "Pakiet autoodnawialny": "Auto-renewable package",
        "Pakiet debugowy skopiowany do schowka.": "Debug package copied to clipboard.",
        "Pakiety": "Packages",
        "Parametry email": "Email parameters",
        "PayU": "PayU",
        "Pełna strona": "Full page",
        "Pełna szerokość": "Full width",
        "Pełny adres aktywnej strony": "Full address of the active site",
        "Pełny adres wraz z \"http(s)://\".": "Full address including \"http(s)://\".",
        "Piątek": "Friday",
        "Pierwsza strona z listy jest identyfikowana przez system jako CANONICAL, czyli informuje roboty wyszukiwarki, która ze zduplikowanych stron jest tą z oryginalną treścią.": "The first page in the list is identified by the system as CANONICAL, which means it tells search engine robots which of the duplicate pages is the one with the original content.",
        "Pierwsze powiadomienie": "First notification",
        "Pierwsze zdjęcie jest okładką galerii. Kolejność zmienisz przeciąganiem.": "First image is gallery cover. Change order by dragging.",
        "Pierwsze zdjęcie w galerii jest zdjęciem głównym": "The first photo in the gallery is the main photo",
        "Piosenka": "Song",
        "Pisać mogą tylko zalogowani użytkownicy": "Only logged-in users can write",
        "Płatność": "Payment",
        "Płatności cykliczne": "Recurring payments",
        "Płeć": "Gender",
        "Plik": "File",
        "Plik gazetki (PDF)": "Newspaper file (PDF)",
        "Plik gazetki do pobrania (PDF)": "Newspaper file to download (PDF)",
        "Plik graficzny": "Image file",
        "Plik llms.txt": "llms.txt file",
        "Plik wideo": "Video file",
        "Plik z repozytorium albo adres URL": "File from repository or URL",
        "Pliki do pobrania dostępne w ramach treści premium.": "Downloadable files available as part of premium content.",
        "Pliki do pobrania pod wpisem": "Downloadable files under post",
        "Pliki dokumentu": "Document files",
        "Pliki dostępne do pobrania przy artykule.": "Files available for download with article.",
        "Pliki gazetki": "Newsletter files",
        "Płyta z muzyką": "Music CD",
        "Po aktywacji odwiedzający zobaczą komunikat o przerwie technicznej. Użytkownicy z uprawnieniami administratora nadal mają dostęp do witryny.": "Once activated, visitors will see a maintenance message. Users with administrator privileges will still have access to site.",
        "Po otwarciu listy widzisz pierwsze wyniki. Wpisz początek wartości z pola identyfikującego, aby zawęzić listę.": "After opening the list, you see the first results. Type the beginning of the value from the identifying field to narrow the list.",
        "Po potwierdzeniu e-maila konto wymaga zatwierdzenia przez administratora.": "After email confirmation, account requires approval by an administrator.",
        "Po przekroczeniu komentarz trafia do moderacji.": "Once exceeded, comment is sent for moderation.",
        "Po tym czasie nieopłacone zamówienie wygasa.": "After this time, unpaid order expires.",
        "Po zakończeniu subskrypcji": "After subscription ends",
        "Po zapisaniu artykułu w wybranej wersji językowej, nie będzie możliwości jej zmiany.": "After saving article in selected language version, it cannot be changed.",
        "Po zapisaniu nie można jej zmienić.": "It cannot be changed after saving.",
        "Po zapisie rekord będzie dostępny w edytorze powiązań Live Design.": "After saving, record will be available in Live Design relationship editor.",
        "Pobieranie płatności dla subskrypcji autoodnawialnych.": "Payment collection for auto-renewing subscriptions.",
        "Pobierz wyniki": "Download the results",
        "Poczta": "Mail",
        "Pod spodem nadal masz otwarty podgląd aranżacji.": "Layout preview is still open below.",
        "Podaj adres docelowy i sposób otwierania odnośnika.": "Enter destination address and how link should open.",
        "Podaj adres url...": "Enter the url...",
        "Podaj identyfikatory administratorów Facebooka, oddzielając je przecinkami.": "Enter Facebook administrator IDs, separated by commas.",
        "Podaj liczbę całkowitą od 1 do 50.": "Enter an integer from 1 to 50.",
        "Podaj pełny adres wraz z protokołem.": "Enter full address including protocol.",
        "Podaj poprawny adres e-mail.": "Enter a valid email address.",
        "Podaj temat, długość i ton tekstu…": "Enter topic, length and tone of text…",
        "Podążanie za linkami": "Links following",
        "Podgląd": "Preview",
        "Podgląd aranżacji": "Layout preview",
        "Podgląd artykułu": "Article preview",
        "Podgląd JSON": "JSON preview",
        "Podgląd Open Graph": "Open Graph preview",
        "Podgląd opublikowanej wersji aranżacji.": "Preview of published layout version.",
        "Podgląd otwiera aktualnie opublikowany plik. Przy wyłączonej publikacji plik jest niedostępny. Tytuły i opisy zmienisz w treściach lub metadanych CMS — plik powstaje przy otwieraniu i nie wymaga ponownego generowania.": "Preview opens currently published file. When publishing is disabled, file is unavailable. Change titles and descriptions in CMS content or metadata — file is generated when opened and does not need to be regenerated.",
        "Podgląd pokazuje zapisane reguły. Zapisz witrynę, aby sprawdzić wprowadzone zmiany.": "Preview shows saved rules. Save site to check changes.",
        "Podgląd strony": "Page preview",
        "Podgląd w mediach społecznościowych.": "Social media preview.",
        "Podgląd wartości pola": "Field value preview",
        "Podgląd wersji roboczej aranżacji.": "Preview of draft layout version.",
        "Podgląd został odświeżony, ale schema formularza nie zmieniła się. Sprawdź, czy zapisana wersja jest tą, którą zwraca endpoint schemy.": "Preview has been refreshed, but form schema has not changed. Check whether saved version is the one returned by schema endpoint.",
        "Podłącz linki": "Connect links",
        "Podłącz linki wewnętrzne": "Connect internal links",
        "Podpis schemy": "Schema signature",
        "Podstawowe": "Basic",
        "Podstawowe informacje": "Basic information",
        "Podwójna linia ciągła": "Double solid line",
        "Pojedyncza publikacja": "Single publication",
        "Pojedyńcza, prosta, ciągła linia": "Single, simple, solid line",
        "Pojedynczy artykuł (strona opisowa)": "Single article (descriptive page)",
        "Pokaż etykietę": "Show tag",
        "Pokaż niedostępne widgety": "Show unavailable widgets",
        "Pokaż skróty": "Show shortcuts",
        "Pokaż w podglądzie": "Show in preview",
        "Pokaż więcej": "Show more",
        "Pokazuj niedostępne widżety": "Show unavailable widgets",
        "Pokazuje samą treść artykułu, bez dodatkowej oprawy.": "Shows article content only, without additional styling.",
        "Pola": "Fields",
        "Pola wypełniane podczas wstawiania shortcode.": "Fields completed when inserting shortcode.",
        "Pole \"%0\" jest wymagane.": "Field ''%0'' is required.",
        "Pole \"Ilość dni przed\" jest wymagane.": "Field \"Days before\" is required.",
        "Pole \"Język\" jest wymagane.": "Field \"Language\" is required.",
        "Pole \"Metryka\" jest wymagane.": "Field \"Metric\" is required.",
        "Pole \"Nazwa\" jest wymagane.": "Field \"Name\" is required.",
        "Pole \"Sortuj według\" jest wymagane.": "Field \"Sort by\" is required.",
        "Pole \"Witryna\" jest wymagane.": "Field \"Site\" is required.",
        "Pole \"Wymiar\" jest wymagane.": "Field \"Dimension\" is required.",
        "Pole identyfikujące dokument": "Document identifier field",
        "Pole jest puste.": "Field is empty.",
        "Pole jest widoczne, ale kliknięcie prowadzi do edytora formularzowego.": "Field is visible, but clicking opens form editor.",
        "Pole jest widoczne, ale nie ma osobnego klikalnego targetu inline. Otworzy się edytor formularzowy.": "Field is visible, but has no separate clickable inline target. Form editor will open.",
        "Pole można edytować bezpośrednio w podglądzie.": "Field can be edited directly in preview.",
        "Pole nie ma widocznego elementu w aktualnym podglądzie.": "Field has no visible element in current preview.",
        "Pole pasuje do kilku elementów w podglądzie. Wybierz target ręcznie w Live Design.": "Field matches multiple elements in preview. Select target manually in Live Design.",
        "Polski": "Polish",
        "Polubienia": "Likes",
        "Polubienia tylko po zalogowaniu": "Likes only when logged in",
        "Pomoc": "Help",
        "Pomocna": "Helpful",
        "Ponawianie...": "Retrying...",
        "Poniedziałek": "Monday",
        "Ponów": "Retry",
        "Ponów ostatnią cofniętą zmianę inline": "Redo last undone inline change",
        "Ponowiono operację na widgetu": "Widget operation redone",
        "Popraw błędy ortograficzne i interpunkcyjne": "Fix spelling and punctuation errors",
        "Popraw literówki, zachowaj oryginalny styl": "Fix typos, keep original style",
        "Popraw merytorycznie": "Improve accuracy",
        "Popraw nieścisłości i uprość sformułowania": "Correct inaccuracies and simplify wording",
        "Popraw odmianę i zgodność form gramatycznych": "Correct inflection and grammatical agreement",
        "Poprzedni okres": "Previous period",
        "Poprzednie pole": "Previous field",
        "Popularność": "Popularity",
        "Porównanie wersji": "Version comparison",
        "Porównano pola formularza": "Form fields compared",
        "Potwierdź": "Confirm",
        "Potwierdź akceptację": "Confirm acceptance",
        "Potwierdź oznaczenie zamówienia jako opłacone.": "Confirm marking order as paid.",
        "Potwierdź przywrócenie wersji roboczej": "Confirm restoration of draft version",
        "Potwierdź usunięcie": "Confirm deletion",
        "Potwierdź usunięcie regulaminu {name}": "Confirm deletion of terms and conditions {name}",
        "Potwierdź usunięcie slajdu {number}": "Confirm deletion of slide {number}",
        "Potwierdź usunięcie zestawu {name}": "Confirm deletion of set {name}",
        "Potwierdzenie mailowe": "Email confirmation",
        "Potwierdzenie mailowe i akceptacja administratora": "Email confirmation and administrator approval",
        "Potwierdzenie przywrócenia": "Confirmation of restoration",
        "Potwierdzenie usunięcia": "Deletion confirmation",
        "Potwierdzenie wysłania": "Confirmation of dispatch",
        "Potwierdzenie zatwierdzenia": "Approval confirmation",
        "Potwierdzenie zmiany statusu": "Confirm status change",
        "Potwierdzone": "Confirmed",
        "Powiadomienia": "Notifications",
        "Powiązana galeria": "Related gallery",
        "Powiązana kategoria": "Related category",
        "Powiązane artykuły": "Related articles",
        "Powiązane galerie": "Related galleries",
        "Powiązane kategorie": "Related categories",
        "Powiązane opinie": "Related reviews",
        "Powiązane rekordy": "Related records",
        "Powiązane wideo": "Related video",
        "Powiązanie": "Relationship",
        "Powiązany artykuł": "Related article",
        "Powiązany autor": "Related author",
        "Powiązany obiekt": "Related object",
        "Powód": "Reason",
        "Powody zgłoszeń": "Report reasons",
        "Powrót": "Back",
        "poza DOM": "outside DOM",
        "Poza DOM": "Outside DOM",
        "Pozostałe ustawienia": "Other settings",
        "Pozostaw puste, aby nie ustawiać daty końcowej.": "Leave empty to not set an end date.",
        "Pozostaw puste, jeśli komunikat nie ma daty końcowej.": "Leave empty if message has no end date.",
        "Pozwala dostawcom AI pobierać treści do uczenia modeli i uzupełniania odpowiedzi. Reguła jest zapisywana w robots.txt, niezależnie od publikacji llms.txt.": "Allows AI providers to retrieve content for model training and completing responses. Rule is saved in robots.txt, regardless of whether llms.txt is published.",
        "Pozwala robotom wyszukiwarek AI przeglądać treści witryny. Reguła trafia automatycznie do robots.txt po zapisaniu witryny.": "Allows AI search engine bots to crawl site content. Rule is automatically added to robots.txt when site is saved.",
        "Pozwala użytkownikom przekazywać komentarze do moderacji.": "Allows users to submit comments for moderation.",
        "Pozycje z lewej": "Items on the left",
        "Pozycje z prawej": "Items on the right",
        "Premiera": "Premiere",
        "Premium": "Premium",
        "Premium otwarty": "Premium open",
        "Prezentacja": "Presentation",
        "Priorytet": "Priority",
        "Priorytet (priority)": "Priority (priority)",
        "Priorytet publikacji": "Publication priority",
        "Produkcyjne": "Manufacturing",
        "Profil użytkownika": "Profile",
        "Projekt aranżacji": "Layout design",
        "Proporcja {ratio} : 1": "Ratio {ratio} : 1",
        "Propozycja": "Proposal",
        "Prosty": "Simple",
        "Protokół OAuth - clientId": "OAuth protocol - clientId",
        "Protokół OAuth - clientSecret": "OAuth protocol - clientSecret",
        "Przechowywanie danych witryny w pamięci podręcznej.": "Caching site data.",
        "Przeciągnij autorów, aby ustalić kolejność ich wyświetlania na stronie.": "Drag authors to set the order in which they appear on the page.",
        "Przeciągnij kategorie, aby ustalić kolejność ich wyświetlania na stronie.": "Drag categories to set the order in which they appear on the page.",
        "Przeciągnij pakiety, aby ustalić kolejność ich wyświetlania.": "Drag packages to set the order in which they appear.",
        "Przeciągnij tutaj widget z biblioteki.": "Drag a widget here from the library.",
        "Przeciągnij widżet do sekcji lub kliknij, aby wybrać miejsce i skonfigurować jego treść.": "Drag a widget to a section or click to select a location and configure its content.",
        "Przeciągnij, aby zmienić kolejność": "Drag to change order",
        "Przed zakończeniem subskrypcji": "Before subscription ends",
        "Przeglądarka": "Browser",
        "Przejdź": "Go",
        "Przejdź do aranżacji": "Go to layout",
        "Przejdź do poprzedniego lub następnego pola inline": "Go to previous or next inline field",
        "Przejść do edycji menu bez zapisywania zmian?": "Go to menu editing without saving changes?",
        "Przekierowania": "Redirects",
        "Przekierowanie aktywne": "Redirection active",
        "Przekierowanie zostało usunięte.": "The redirect has been removed.",
        "Przekierowanie zostało zapisane.": "Redirect has been saved.",
        "przekroczony": "exceeded",
        "Przełącz": "Toggle",
        "Przełączenie na tryb statyczny usunie zdefiniowane sekcje dynamiczne dla tego typu aranżacji.": "Switching to static mode will remove defined dynamic sections for this layout type.",
        "Przenieś artykuł": "Move article",
        "Przenieś do sekcji": "Move to section",
        "Przenieś kategorię niżej": "Move category down",
        "Przenieś kategorię wyżej": "Move category up",
        "Przenieś niżej": "Move lower",
        "Przenieś odpowiedź {number}": "Move answer {number}",
        "Przenieś opinię {number}": "Move review {number}",
        "Przenieś plik": "Move file",
        "Przenieś później": "Move later",
        "Przenieś pytanie {number}": "Move question {number}",
        "Przenieś pytanie niżej": "Move question down",
        "Przenieś pytanie wyżej": "Move question up",
        "Przenieś sekcję {name}": "Move section {name}",
        "Przenieś slajd {number} w dół": "Move slide {number} down",
        "Przenieś slajd {number} w górę": "Move slide {number} up",
        "Przenieś treść modułu": "Move module content",
        "Przenieś wcześniej": "Move earlier",
        "Przenieś widżet {name}": "Move widget {name}",
        "Przenieś wyżej": "Move higher",
        "Przeniesiono widget": "Widget moved",
        "Przepisz zaznaczony fragment i podziel go na akapity": "Rewrite selected text and split it into paragraphs",
        "Przepisz zaznaczony fragment i skróć go o połowę": "Rewrite selected text and shorten it by half",
        "Przepisz zaznaczony fragment, pozostawiając dane i liczby": "Rewrite selected text, preserving facts and figures",
        "Przepisz zaznaczony fragment, zachowując jego sens": "Rewrite selected text, preserving its meaning",
        "Przeredaguj zaznaczony fragment na bardziej formalny": "Rewrite selected text in a more formal tone",
        "Przerwa techniczna": "Technical break",
        "Przesuń do góry": "Move up",
        "Przesuń niżej": "Move down",
        "Przesuń w dół": "Move down",
        "Przesuń wyżej": "Move up",
        "Przetłumacz i dostosuj tekst do lokalnego czytelnika": "Translate and adapt text for a local reader",
        "Przetłumacz zaznaczony fragment w stylu formalnym": "Translate selected text in a formal style",
        "Przetłumacz zaznaczony fragment, pozostawiając nazwy własne bez zmian": "Translate selected text, leaving proper names unchanged",
        "Przetłumacz zaznaczony fragment, zachowując ton wypowiedzi": "Translate selected text, preserving its tone",
        "Przygotowuję formularz edycji.": "Preparing edit form.",
        "Przypięto dev details": "Pinned dev details",
        "Przypisz pola tytułu, opisu i daty do klucza modułu Studio. Puste pole pozostawia domyślne mapowanie.": "Map title, description, and date fields to a Studio module key. Leave a field empty to use the default mapping.",
        "Przypnij": "Pin",
        "Przywróć": "Reload",
        "Przywróć kolejność domyślną": "Restore default order",
        "Przywróć wszystkie": "Restore all",
        "Pseudonim": "Pseudonym",
        "Publiczne ID": "Public ID",
        "Publikacja": "Publication",
        "Publikacja dokumentu": "Document publication",
        "Publikacja galerii przez użytkownika": "Publication of galleries by user",
        "Publikacja nie gwarantuje użycia treści przez konkretnego dostawcę AI.": "Publication does not guarantee that a specific AI provider will use the content.",
        "Publikacja priorytetowa": "Priority publication",
        "Publikacja strony i jej obecność w menu.": "Page publication and its presence in the menu.",
        "Publikacja wideo przez użytkownika": "User video publication",
        "Publikacja zarchiwizowana": "Archived publication",
        "Publikacja została dodana.": "The publication has been added.",
        "Publikacja została usunięta.": "The publication has been deleted.",
        "Publikuj": "Publish",
        "Publikuj do": "Publish to",
        "Publikuj llms.txt": "Publish llms.txt",
        "Publikuj na stronie": "Publish to page",
        "Publikuj na wybranej stronie": "Publish on the site of your choice",
        "Publikuj od": "Publish from",
        "Publikuj slajd {number} do": "Publish slide {number} to",
        "Publikuj slajd {number} od": "Publish slide {number} from",
        "Publikuj slajder do": "Publish slider to",
        "Pusta sekcja": "Empty section",
        "puste": "empty",
        "Puste – bez daty końcowej.": "Empty – no end date.",
        "Puste = bez daty końcowej.": "Empty = no end date.",
        "Pusty układ — zacznij od własnej kompozycji.": "Empty layout — start with your own composition.",
        "Pytania i odpowiedzi": "Questions & Answers",
        "Pytanie": "Question",
        "razy": "times",
        "Recaptcha": "Recaptcha",
        "Ręczna akceptacja wszystkich komentarzy": "Manually accept all comments",
        "Ręczny wybór zdjęć lub galerii": "Manual selection of photos or gallery",
        "Redakcja": "Editorial team",
        "Redaktor został zaktualizowany.": "The editor has been updated.",
        "Region": "Region",
        "Regulamin wymagany": "Regulations required",
        "Regulamin został dodany.": "Regulations have been added.",
        "Regulamin został zaktualizowany.": "Ragulations have been updated.",
        "Regulaminy": "Regulations",
        "Regulaminy z zapisaną datą odrzucenia.": "Terms and conditions with a recorded rejection date.",
        "Regulaminy zaakceptowane przez użytkownika.": "Terms and conditions accepted by user.",
        "Reguły wygaśnięcia i anulowania nieopłaconych zamówień.": "Rules for expiration and cancellation of unpaid orders.",
        "Rejestracja": "Registration",
        "Rejestracja konta": "Sign-up",
        "Repozytorium": "Repository",
        "Repozytorium plików": "File repository",
        "Reżyseria": "Direction",
        "Robocza": "Draft",
        "Roboty nie podążają za tym odnośnikiem.": "Crawlers do not follow this link.",
        "Rodzaj adresu kanonicznego": "Type of canonical address",
        "Rodzaj pozycji menu": "Menu item type",
        "Rodzaj strony": "Page type",
        "Rodzaj źródła": "Source type",
        "Rotator": "Rotator",
        "Rotator został dodany.": "Rotator has been added.",
        "Rotator został usunięty.": "The rotator has been removed.",
        "Rotator został zaktualizowany.": "The rotator has been updated.",
        "Rotatory opinii": "Opinion rotators",
        "Rozbudowany": "Expanded",
        "Rozbuduj i podziel na dwa akapity": "Expand and split into two paragraphs",
        "Rozbuduj tekst": "Expand text",
        "Rozciąga artykuł na pełną szerokość strony.": "Expands article to full page width.",
        "Rozpoczęcie pobrania płatności przed końcem subskrypcji": "Starting payment collection before subscription ends",
        "Rozwiń akapit o korzyściach dla redakcji": "Expand paragraph about benefits for editorial team",
        "Rozwiń do": "Expand to",
        "Rozwiń fragment o dwa zdania, zachowując ton wypowiedzi": "Expand text by two sentences, preserving its tone",
        "Rozwiń panel podglądu": "Expand preview panel",
        "RSS": "RSS",
        "Scenariusz": "Scenario",
        "schema bez zmian": "schema unchanged",
        "Schema formularza bez zmian": "Form schema unchanged",
        "schema OK": "schema OK",
        "schema po refreshu": "schema after refresh",
        "Schema URL": "Schema URL",
        "Ścieżka": "Path",
        "Ścieżka aktywnej strony": "Path of the active page",
        "Ścieżka nawigacyjna": "Navigation path",
        "ścieżka strony CMS": "CMS page path",
        "sek.": "sec.",
        "Sekcja": "Section",
        "Sekcja %0": "Section %0",
        "Sekcja aranżacji": "Layout section",
        "Sekcja docelowa": "Target section",
        "Sekcja komentarzy": "Comments section",
        "Sekcja modułu": "Module section",
        "Sekcja pod artykułem": "Section under the article",
        "Sekcja śródtekstowa": "Intra-text section",
        "Sekcja wybranego modułu używana przez widżet.": "Section of selected module used by widget.",
        "Sekcje": "Sections",
        "Sekcje szablonu": "Template sections",
        "Sekcje treści": "Content sections",
        "Sekcje użytkownika": "User sections",
        "SEO": "SEO",
        "Separator elementów w tytule": "Element separator in title",
        "Separator tytułu i generowanie mapy witryny.": "Title separator and sitemap generation.",
        "Serial telewizyjny": "Television series",
        "Serie kresek lub fragmentów linii": "Series of dashes or line segments",
        "Serie kropek": "Series of dots",
        "Serwis": "Service",
        "Shorcode nie istnieje. Usuń go z edytora.": "Shortcode does not exist. Delete it from editor.",
        "Shortcode": "Shortcode",
        "Shortcode testowy": "Test shortcode",
        "ShortCode został dodany.": "ShortCode has been added.",
        "Shortcode został usunięty": "Shortcode has been deleted",
        "ShortCode został zaktualizowany.": "ShortCode has been updated.",
        "Shortcodes": "Shortcodes",
        "Sitemap nie wskazuje formularza dla tej schemy.": "Sitemap does not specify a form for this schema.",
        "Sitemapy": "Sitemaps",
        "Skopiowano": "Copied",
        "Skopiowano dev details": "Dev details copied",
        "Skopiowano JSON szablonu do schowka.": "Template JSON copied to clipboard.",
        "Skopiowano link do widgetu": "Widget link copied",
        "Skopiowano pakiet debugowy": "Debug package copied",
        "Skrócony opis": "Short description",
        "Skróty klawiszowe": "Keyboard shortcuts",
        "Skrypty statystyczne, np. Analytics lub Matomo. Są dodawane w górnej części <head> witryny.": "Statistical scripts, e.g. Analytics or Matomo. Added to top of website's <head>.",
        "Skrypty targetujące, np. Google Tag Manager lub Pixel Facebook. Są dodawane w górnej części <body> witryny.": "Targeting scripts, e.g. Google Tag Manager or Facebook Pixel. Added to top of website's <body>.",
        "Skrypty zewnętrzne": "External scripts",
        "Skup na tym bloku": "Focus on this block",
        "Skupiono widget": "Widget focused",
        "Slajd {number}": "Slide {number}",
        "Slajder został dodany.": "The slider has been added.",
        "Slajder został usunięty.": "The slider has been removed.",
        "Slajder został zaktualizowany.": "The slider has been updated.",
        "Slajdery": "Sliders",
        "słów": "words",
        "Słowa kluczowe": "Keywords",
        "Słowa kluczowe opisujące artykuł": "Keywords describing article",
        "Słowa oddzielone przecinkami.": "Words separated by commas.",
        "Słowo": "Word",
        "Słowo lub wyrażenie zamieniane na link.": "Word or phrase replaced with a link.",
        "slug lub tytuł": "slug or title",
        "slug strony z listą": "slug of listing page",
        "slug tytułu": "title slug",
        "slugifikowany pełny tytuł treści w języku sitemapy": "slugified full content title in sitemap language",
        "slugifikowany tytuł": "slugified title",
        "Sobota": "Saturday",
        "Sortowanie": "Sorting",
        "Sortowanie autorów": "Author sorting",
        "Sortowanie kategorii": "Sorting categories",
        "Sortowanie pakietów": "Package sorting",
        "Sortuj autorów": "Sort authors",
        "Sortuj kategorie": "Sort Categories",
        "Sortuj pakiety": "Sort packages",
        "Sortuj według": "Sort by",
        "Specjalne role w serwisie": "Special roles in service",
        "Sposób ładowania obrazów w tej sekcji": "Image loading method in this section",
        "Sposób ładowania obrazów w tej sekcji (dziedziczony przez aranżacje)": "Image loading method in this section (inherited by layouts)",
        "Sposób publikacji nowych komentarzy.": "How new comments are published.",
        "Sprawdź gramatykę": "Check grammar",
        "Sprawdź nazwę kategorii.": "Check category name.",
        "Sprawdź połączenie i spróbuj ponownie.": "Check connection and try again.",
        "Sprawdź poprawność faktów i nazw własnych": "Check facts and proper names",
        "Sprawdź, czy w treści nie ma powtórzeń": "Check for repetitions in content",
        "Spróbuj pobrać listę ponownie.": "Try downloading list again.",
        "Spróbuj ponownie": "Try again",
        "Środa": "Wednesday",
        "Środowisko": "Environment",
        "stały identyfikator": "Permanent identifier",
        "Stara cena brutto": "Old gross price",
        "Status": "Status",
        "Status aranżacji został zmieniony.": "The status of the arrangement has been changed.",
        "Status artykułu": "Article status",
        "Status baneru został zmieniony.": "The status of the banner has been changed.",
        "Status dokumentu został zmieniony.": "The status of the document has been changed.",
        "Status galerii został zmieniony.": "The status of the gallery has been changed.",
        "Status komentarzy": "Comment status",
        "Status linku został zmieniony.": "The status of the link has been changed.",
        "Status przekierowania został zmieniony.": "Redirect status has been changed.",
        "Status regulaminu został zmieniony.": "The status of the regulations has been changed.",
        "Status wideo został zmieniony.": "The status of the video has been changed.",
        "Status zamówienia": "Order status",
        "Statyczny": "Static",
        "Streść fragment w dwóch zdaniach": "Summarize excerpt in two sentences",
        "Streść fragment w pięciu punktach": "Summarize excerpt in five bullet points",
        "Streść treść w pięciu punktach": "Summarize content in five bullet points",
        "Streszczenie": "Summary",
        "Strona": "Page",
        "Strona błędu 404": "404 error page",
        "Strona CMS": "CMS page",
        "Strona do publikacji": "Page to publish",
        "Strona docelowa dla 'Czytaj więcej'": "The landing page for 'Read more'",
        "Strona docelowa dla 'Kontakt z adminem'": "Destination page for 'Contact Admin'",
        "Strona docelowa dla 'Pliki cookies'": "Landing page for 'Cookies'",
        "Strona docelowa dla 'Polityka prywatności'": "Landing page for 'Privacy Policy'",
        "Strona dostępna dla wszystkich": "Website available to everyone",
        "Strona dostępna tylko dla zalogowanych użytkowników": "Page available only to logged in users",
        "Strona głowna": "Home page",
        "Strona główna": "Home",
        "Strona główna serwisu": "Service home page",
        "Strona kanoniczna": "Canonical page",
        "Strona konta użytkownika powiązana z powiadomieniami.": "User account page linked to notifications.",
        "Strona korzystająca tylko z aranżacji": "Page using layout only",
        "Strona korzystająca z modułu": "Page using module",
        "Strona logowania użytkowników": "User login page",
        "Strona nadrzędna": "Parent page",
        "Strona obsługująca logowanie i konto użytkownika.": "Page handling login and user account.",
        "Strona opublikowana": "Published page",
        "Strona ukryta w menu": "Page hidden from menu",
        "Strona utworzona w PageBuilderze": "Page created in PageBuilder",
        "Strona z modułu konto użytkownika": "Page from the user account module",
        "Strona z modułu wyszukiwarki": "Page from the search engine module",
        "Strona została dodana.": "The page has been added.",
        "Strona została usunięta.": "The page has been deleted.",
        "Strona została zaktualizowana.": "The page has been updated.",
        "Strona, na której użytkownik znajdzie kontakt do administratora.": "Page where user can find administrator's contact details.",
        "Strona, na której wyświetlane są wyniki wyszukiwania.": "Page displaying search results.",
        "Strona/kategoria nadrzędna": "Parent page/category",
        "Strony": "Page",
        "Strony gazetki": "Newspaper pages",
        "Strony publikacji": "Publication pages",
        "Strony z treścią": "Pages with content",
        "Struktura menu": "Menu structure",
        "Struktura serwisu": "Site structure",
        "Struktura stron": "Page structure",
        "Studio": "Studio",
        "Studio obsługuje również pola formularza. Klucz szablonu ma postać „symbolModułu/symbolSekcji”.": "Studio also supports form fields. Template key has format “moduleSymbol/sectionSymbol”.",
        "Styl tekstu": "Text style",
        "Styl Tekstu": "Text Style",
        "Subskrypcja": "Subscription",
        "Subskrypcja aktywna": "Active subscription",
        "Subskrypcje": "Subscriptions",
        "Subskrypcje klienta": "Client subscriptions",
        "Suma": "Sum",
        "Suma proporcji musi wynosić 100%. Pozostałe kolumny przejdą do kolejnego wiersza.": "Sum of proportions must be 100%. Remaining columns will move to next row.",
        "Sygnatura widoczna na listingu.": "Signature displayed in listing.",
        "Symbol": "Symbol",
        "Symbol autora": "Author Symbol",
        "Symbol linku": "Link symbol",
        "Symbol może składać się tylko z małych liter, cyfr oraz znaku -": "The symbol can only consist of lowercase letters, numbers and the character -",
        "Symbol może składać się tylko z małych liter, cyfr oraz znaku - ": "A symbol can only consist of lowercase letters, numbers, and a character - ",
        "Symbol może składać się tylko z małych liter, cyfr oraz znaku -.": "Symbol can contain only lowercase letters, digits, and -.",
        "Symbol strony": "Page symbol",
        "Symboliczne miejsce na treść modułu strony korzystającej z tego typu aranżacji.": "Placeholder for content of page module using this layout type.",
        "Synchronizuj": "Sync",
        "System": "System",
        "System operacyjny": "Operating system",
        "Szablon nie określa miejsca treści modułu.": "Template does not specify a place for module content.",
        "Szablon określa sekcje, w których możesz umieszczać widgety. Wybierz układ odpowiedni dla tej strony.": "Template specifies sections where you can place widgets. Choose a layout suitable for this page.",
        "Szablon określa układ wiadomości. W wysyłce używana jest jego opublikowana wersja.": "Template specifies message layout. Its published version is used when sending.",
        "Szablon wiadomości": "Message template",
        "Szablon został dodany.": "The template has been added.",
        "Szablon został usunięty.": "The template has been removed.",
        "Szablon został zaktualizowany.": "The template has been updated.",
        "Szablony": "Templates",
        "Szablony adresów URL wpisów w formacie JSON.": "Post URL templates in JSON format.",
        "Szablony URL": "URL templates",
        "Szablony URL (JSON)": "URL templates (JSON)",
        "Szczegóły": "Details",
        "Szczegóły klienta": "Customer details",
        "Szczegóły regulaminu": "Terms and conditions details",
        "Szczegóły techniczne": "Technical details",
        "Szczegóły wpisu": "Entry details",
        "Szczegóły zamówienia": "Order details",
        "Szerokość": "Width",
        "Szerokość podglądu": "Preview width",
        "Szerokość podglądu: {width} px": "Preview width: {width} px",
        "Szukaj aranżacji": "Search layouts",
        "Szukaj aranżacji…": "Search layouts…",
        "Szukaj sekcji": "Search sections",
        "Szukaj sekcji…": "Search sections…",
        "Szukaj strony": "Search page",
        "Szukaj widżetu": "Search widget",
        "Szukaj widżetu…": "Search widget…",
        "Ta aranżacja zostanie użyta, jeśli nie przypisano żadnej innej aranżacji do strony.": "This layout will be used if no other layout has been assigned to the page.",
        "Ta treść jest współdzielona przez wszystkie użycia tego widgetu.": "This content is shared across all uses of this widget.",
        "Tablet": "Tablet",
        "Tagi": "Tags",
        "Tagi nie są widoczne w przypadku zaznaczenia opcji \"Tylko treść artykułu\".": "Tags are not visible when \"Article content only\" is selected.",
        "Tak": "Yes",
        "Target": "Target",
        "Te funkcje korzystają z Googlebota. Powyższe ustawienia nie oddzielają ich od zwykłego indeksowania Google Search.": "These features use Googlebot. Settings above do not separate them from regular Google Search indexing.",
        "Te ustawienia służą do przygotowania wyglądu wiadomości wysyłanych w ramach automatyzacji tej witryny. Wybierz domyślne logo i szablon oraz przygotuj stopkę dla poszczególnych języków, aby e-maile miały spójny wygląd.": "These settings are used to prepare the appearance of messages sent through this site's automation. Select a default logo and template, and prepare a footer for each language to keep emails consistent.",
        "Tekst": "Text",
        "Tekst formatowany": "Formatted text",
        "Tekst prezentowany przy formularzu zapisu do newslettera.": "Text displayed next to newsletter signup form.",
        "Tekst wyświetlany nad galerią": "Text displayed above gallery",
        "Tekst wyświetlany nad gazetką": "Text displayed above newsletter",
        "Tekstowy / HTML / JS": "Text / HTML / JS",
        "Telefon": "Phone",
        "Ten komentarz nie ma zgłoszeń do moderacji.": "This comment has no moderation reports.",
        "Ten komponent nie ma dodatkowych opcji do skonfigurowania.": "This component has no additional options to configure.",
        "Ten widget nie jest dostępny w żadnej sekcji tej aranżacji.": "This widget is not available in any section of this layout.",
        "Ten widget nie może zostać przeniesiony do wskazanej sekcji.": "This widget cannot be moved to specified section.",
        "Ten widżet nie ma dodatkowej konfiguracji": "This widget has no additional configuration",
        "Ten wpis jest już wykorzystywany w treści, dlatego jego ustawienia są zablokowane. Możesz sprawdzić obecną konfigurację. Jeśli potrzebujesz innych ustawień, wróć do listy i dodaj nowy link wewnętrzny.": "This post is already used in content, so its settings are locked. You can check current configuration. If you need different settings, go back to list and add a new internal link.",
        "Ten wpis jest użyty w aranżacjach:": "This post is used in layouts:",
        "Termin publikacji": "Publication date",
        "Testowe": "Test",
        "Testowe służy do sprawdzania integracji, a Produkcyjne do rzeczywistych płatności. Wprowadź dane punktu POS zgodne z wybranym środowiskiem.": "Test is used to check integrations, while Production is used for real payments. Enter POS terminal details that match selected environment.",
        "Tłumaczenie": "Translation",
        "Tokeny": "Tokens",
        "Tonalność tekstu": "Text tone",
        "Tonalność Tekstu": "Text Tone",
        "Top temat został dodany.": "Top topic has been added.",
        "Top temat został usunięty.": "The top topic has been removed.",
        "Top temat został zaktualizowany.": "Top topic has been updated.",
        "Top tematy": "Top Topics",
        "Transfer": "Transfer",
        "Transfer sekcji": "Transfer section",
        "Transfer strony": "Transfer page",
        "Treść": "Content",
        "Treść aktualności": "News content",
        "Treść bez nazwy": "Unnamed content",
        "Treść generowana przez AI – sprawdź ją przed wstawieniem.": "AI-generated content – review it before inserting.",
        "Treść i kolejność slajdów są zarządzane w wybranym rotatorze.": "Slide content and order are managed in selected rotator.",
        "Treść komentarza": "Comment content",
        "Treść komunikatu wyświetlana na stronie.": "Message content displayed on page.",
        "Treść linku": "Link text",
        "Treść modułu": "Module content",
        "Treść na końcu wiadomości, np. dane kontaktowe firmy. Przygotuj ją osobno dla każdego języka. Puste pole korzysta z domyślnej stopki systemu.": "Content at end of message, e.g. company contact details. Prepare it separately for each language. If left empty, default system footer is used.",
        "Treść nie może być pusta.": "The content must not be empty.",
        "Treść odpowiedzi": "Answer content",
        "Treść opinii wyświetlana na stronie": "Review content displayed on page",
        "Treść powstaje z sekcji i widgetów aranżacji. Strona nie korzysta z modułu.": "Content is created from layout sections and widgets. Page does not use a module.",
        "Treść premium": "Premium content",
        "Treść pytania widoczna dla użytkowników": "Question text visible to users",
        "Treści": "Content",
        "Treści uwzględniane w wynikach wyszukiwania witryny.": "Content included in site search results.",
        "Treści w tym widżecie": "Content in this widget",
        "Treści widgetu zostały zapisane.": "Widget content has been saved.",
        "Tryb „Z metadanych / generatora” zachowuje wartości ustawione dla stron CMS. Wpisy Studio korzystają z wartości weekly i 0.5. Własna wartość zastępuje je we wszystkich sitemapach. Po zapisaniu ustawień wygeneruj sitemapy ponownie.": "\"From metadata / generator\" mode preserves values set for CMS pages. Studio posts use values weekly and 0.5. A custom value overrides them in all sitemaps. After saving settings, generate sitemaps again.",
        "Tryb galerii": "Gallery mode",
        "Tryb oraz struktura sekcji wynikają z wybranego szablonu.": "Mode and section structure are determined by selected template.",
        "Tryb pracy": "Work mode",
        "Tryb układu": "Layout mode",
        "Tryb wyświetlania": "Display mode",
        "Tydzień": "Week",
        "Tylko 404": "Only 404",
        "Tylko aktywne": "Only active",
        "Tylko data – 2026-09-04": "Date only – 2026-09-04",
        "Tylko gdy odpowiedź serwera jest 404": "Only when the server response is 404",
        "Tylko małe litery, bez znaków specjalnych, cyfr i spacji.": "Lowercase letters only, no special characters, numbers, and spaces.",
        "Tylko priorytetowe": "Priority only",
        "Tylko treść": "Content only",
        "Tylko treść artykułu": "Article content only",
        "Tylko zalogowani użytkownicy mogą polubić komentarz.": "Only logged-in users can like a comment.",
        "Typ": "Type",
        "Typ aranżacji": "Type of arrangement",
        "Typ autora": "Author type",
        "Typ bannera": "Banner type",
        "Typ długości": "Length type",
        "Typ linku": "Link type",
        "Typ obiektu": "Object type",
        "Typ pakietu": "Package type",
        "Typ rankingu": "Ranking type",
        "Typ strony": "Page type",
        "Typ zestawu": "Set type",
        "Typy aranżacji": "Layout types",
        "Tytuł": "Title",
        "Tytuł aktywnej witryny": "Title of the active site",
        "Tytuł dokumentu": "Document title",
        "Tytuł elementu": "Element title",
        "Tytuł i tagi filmu": "Video title and tags",
        "Tytuł i tagi galerii": "Gallery title and tags",
        "Tytuł okładki": "Cover title",
        "Tytuł pomocniczy": "Subtitle",
        "Tytuł pomocniczy jest wyświetlany przed tytułem artykułu.": "Subtitle is displayed before article title.",
        "Tytuł przerwy technicznej": "Technical Break Title",
        "Tytuł strony": "Page title",
        "Tytuł witryny": "Site title",
        "Tytuł wyświetlany na liście filmów i przy materiale wideo.": "Title displayed in video list and next to video.",
        "Tytuł wyświetlany na liście galerii i nad jej zawartością.": "Title displayed in gallery list and above its content.",
        "Tytuł, opis i indeksowanie.": "Title, description, and indexing.",
        "Uczenie modeli i uzupełnianie odpowiedzi": "Model training and answer completion",
        "Udostępnia plik publicznie po zapisaniu witryny. Publikacja jest niezależna od ustawień robotów AI.": "Makes file publicly available after site is saved. Publishing is independent of AI bot settings.",
        "Udostępnia ten artykuł premium bez ograniczania dostępu.": "Makes this premium article available without restricting access.",
        "Udostępnia witrynę odwiedzającym.": "Makes site available to visitors.",
        "Ujednolić terminologię z resztą artykułu": "Align terminology with rest of article",
        "Układ dynamiczny": "Dynamic layout",
        "Układ statyczny": "Static layout",
        "Układ treści oraz moduł obsługujący stronę.": "Content layout and module handling page.",
        "Ukryj": "Hide",
        "Ukryj blok": "Hide block",
        "Ukryj nazwę w aplikacji": "Hide name in app",
        "Ukryte widgety": "Hidden widgets",
        "Ukrywa komentarze przed gośćmi. Wymaga też logowania do dodawania komentarzy i polubień.": "Hides comments from guests. Also requires login to add comments and likes.",
        "Ukrywa możliwość komentowania tego artykułu.": "Hides ability to comment on this article.",
        "Ukrywa nagłówek widżetu na stronie. Jego zawartość pozostaje widoczna, a nazwa w panelu nie zmienia się.": "Hides widget heading on page. Its content remains visible, and its name in panel does not change.",
        "Ukrywa pozycję w menu bez wyłączania dostępu do strony.": "Hides menu item without disabling access to page.",
        "Ukrywa przyciski udostępniania artykułu.": "Hides article sharing buttons.",
        "Umiejscowienie": "Placement",
        "Uprawnienia": "Permissions",
        "Upuść widżet w sekcji {name}": "Drop widget in section {name}",
        "URL": "URL",
        "Urządzenie dla kolejności sekcji": "Device for section order",
        "Usatwienia komentarzy": "Comment settings",
        "Ustaw kategorię": "Set category",
        "Ustaw nazwę, sposób budowania i rozmieszczenie sekcji.": "Set name, building method, and section layout.",
        "Ustaw również dla wszystkich podstron": "Set also for all subpages",
        "Ustawienia": "Settings",
        "Ustawienia aranżacji": "Layout settings",
        "Ustawienia baneru": "Banner settings",
        "Ustawienia dostępności": "Accessibility settings",
        "Ustawienia i wersje regulaminu": "Terms and conditions settings and versions",
        "Ustawienia komentarzy": "Comment settings",
        "Ustawienia modułu": "Module settings",
        "Ustawienia pakietu": "Package settings",
        "Ustawienia płatności": "Payment settings",
        "Ustawienia podstawowe": "Basic settings",
        "Ustawienia redakcji": "Editorial settings",
        "Ustawienia RSS": "RSS settings",
        "Ustawienia sekcji": "Section settings",
        "Ustawienia sitemap": "Sitemap settings",
        "Ustawienia slajdera": "Slider settings",
        "Ustawienia strony": "Page settings",
        "Ustawienia widgetu": "Widget settings",
        "Ustawienia widżetu": "Widget settings",
        "Ustawienia witryny": "Site settings",
        "Ustawienia z definicji szablonu.": "Settings from template definition.",
        "Ustawienia zostały zaktualizowane.": "The settings have been updated.",
        "Ustawienia zostały zapisane.": "Settings have been saved.",
        "Usuń": "Delete",
        "Usuń artykuł z listy": "Remove an article from the list",
        "Usuń autora": "Delete author",
        "Usuń autora z widżetu": "delete author from widget",
        "Usuń blok": "delete block",
        "Usuń dokument": "delete document",
        "Usuń element": "delete item",
        "Usuń katalog": "Delete directory",
        "Usuń kategorię": "Delete category",
        "Usuń odpowiedź": "Delete answer",
        "Usuń opinię": "Delete opinion",
        "Usuń plik": "Delete file",
        "Usuń powiązanie": "Unlink",
        "Usuń powód": "Remove reason",
        "Usuń powtórzenia i skróć bez utraty sensu": "delete duplicates and shorten without losing meaning",
        "Usuń publikację": "Delete a publication",
        "Usuń pytanie": "Delete question",
        "Usuń regulamin {name}": "delete terms and conditions {name}",
        "Usuń sekcję": "delete section",
        "Usuń slajd {number}": "delete slide {number}",
        "Usuń słowo": "Delete word",
        "Usuń stronę": "Delete page",
        "Usuń typ": "delete type",
        "Usuń widget z sekcji": "Remove a widget from a section",
        "Usuń wybrany element": "Delete the selected item",
        "Usuń zestaw {name}": "delete set {name}",
        "Usunąć autora z tego widżetu?": "Delete author from this widget?",
        "Usunąć sekcję wraz z umieszczonymi w niej widgetami?": "Delete section along with widgets placed in it?",
        "Usunąć sekcję?": "Delete section?",
        "Usunąć sekcję? Jej kolumny przestaną być slotami na widgety w aranżacjach.": "Delete section? Its columns will no longer be slots for widgets in layouts.",
        "Usunąć tę sekcję wraz z treścią?": "Delete this section along with its content?",
        "Usunąć widżet z tej sekcji?": "Delete widget from this section?",
        "Usunąć własny typ aranżacji? Istniejące aranżacje korzystające z tego typu przestaną mieć poprawny szablon.": "Delete custom layout type? Existing layouts using this type will no longer have a valid template.",
        "Usunięcie tej strony spowoduje również usunięcie stron podrzędnych.": "Deleting this page will also delete child pages.",
        "Usuniesz {count} końcowych kolumn. Przenieś wcześniej ich widżety w aranżacjach korzystających z tego szablonu.": "You will delete {count} trailing columns. Move their widgets beforehand in layouts using this template.",
        "usunięto": "deleted",
        "Usunięto widget": "Widget deleted",
        "Utwórz nową": "Create new",
        "Uzupełnij automatyczne reguły witryny o własne instrukcje dla robotów.": "Supplement automatic site rules with custom instructions for robots.",
        "Uzupełnij fragment o kontekst dla czytelnika": "Add context for reader to excerpt",
        "Uzupełnij konfigurację po lewej, aby wybrać szablon i rozmieścić widgety.": "Complete configuration on left to select a template and arrange widgets.",
        "Uzupełnij poprawny adres domenowy w Ustawieniach, aby otworzyć podgląd.": "Enter a valid domain address in Settings to open preview.",
        "Użyta na stronach": "Used on pages",
        "Użytkownicy mogą zgłaszać komentarze": "Users can submit comments",
        "Użytkownicy z bazy": "Users from database",
        "Użytkownik dokonał rejestracji samodzielnie.": "User registered independently.",
        "Użytkownik musi potwierdzić adres e-mail.": "User must confirm email address.",
        "Użytkownik z bazy": "User from the base",
        "użytkowników online": "users online",
        "Użyty w {count} innych aranżacjach": "Used in {count} other layouts",
        "Używane jako główna ilustracja artykułu.": "Used as main article illustration.",
        "W aplikacji frontendowej uruchom asystenta komend `npm run edito`, a następnie wklej poniżej zawartość pliku `theme.json` właściwego dla tego szablonu.": "In frontend application, run assistant command `npm run edito`, then paste below contents of `theme.json` file for this template.",
        "W drodze": "On its way",
        "W przypadku braku wartości zostanie wyświetlona nazwa strony.": "If the value is missing, the name of the site will be displayed.",
        "W przypadku zaznaczenia opcji \"Artykuł sponsorowany\" lub \"Opinia\", etykieta jest ustawiona automatycznie.": "If \"Sponsored article\" or \"Opinion\" is selected, label is set automatically.",
        "W trakcie przygotowania": "In preparation",
        "W tym katalogu nie ma jeszcze żadnych stron.": "There are no pages in this directory yet.",
        "W tym miejscu pojawi się treść modułu przypisanego do strony.": "Content of module assigned to page will appear here.",
        "W widoku opublikowanej wersji edycja jest wyłączona.": "Editing is disabled in published version view.",
        "W wybranych aranżacjach dotychczasowa zawartość tej sekcji zostanie zastąpiona.": "In selected layouts, existing content of this section will be replaced.",
        "Walidacja": "Validation",
        "Wartość": "Value",
        "Wartość długości": "Length value",
        "Wartość jest za długa.": "Value is too long.",
        "Wartość może być za długa.": "Value may be too long.",
        "Wartość tekstowa": "Text value",
        "Wczytaj więcej": "Load more",
        "Wczytywanie": "Loading",
        "Wczytywanie formularza…": "Loading form…",
        "Wczytywanie stron": "Loading pages",
        "Wczytywanie ustawień strony…": "Loading page settings…",
        "Wczytywanie zgód": "Loading consents",
        "Wczytywanie...": "Loading...",
        "Wersja": "Version",
        "Wersja językowa": "Language version",
        "Wersja językowa treści i widgetów używanych w tej aranżacji.": "Language version of content and widgets used in this layout.",
        "Wersja podglądu": "Preview version",
        "Wersja robocza została przywrócona.": "The draft version has been restored.",
        "Wersje": "Versions",
        "Wersje językowe": "Language versions",
        "Weryfikacja reCAPTCHA podczas wysyłania formularza.": "reCAPTCHA verification when submitting form.",
        "Wewnętrzny": "Internal",
        "Wiadomość została wysłana.": "The message has been sent.",
        "Wideo": "Video",
        "Wideo nie jest jeszcze nigdzie opublikowane.": "The video is not yet published anywhere.",
        "Wideo nie ma ustawionej daty publikacji.": "The video does not have a publication date set.",
        "Wideo premium": "Premium video",
        "Wideo zostało dodane.": "Video has been added.",
        "Wideo zostało usunięte.": "The video has been removed.",
        "Wideo zostało zaktualizowane.": "The video has been updated.",
        "Widget dynamiczny nie ma kompletnych ustawień modułu.": "Dynamic widget does not have complete module settings.",
        "Widget ID": "Widget ID",
        "Widget jest wyłączony dla tej witryny": "The widget is disabled for this site",
        "Widget służy do wczytania ustawień wiadomości email według wybranej witryny i wersji językowej.": "Widget is used to load email message settings based on selected site and language version.",
        "Widget Studio": "Widget Studio",
        "Widget unikalny może zostać użyty tylko raz": "A unique widget can only be used once",
        "Widget został dodany do aranżacji.": "Widget has been added to layout.",
        "Widget został skopiowany do wskazanej witryny.": "Widget has been copied to specified site.",
        "Widget został usunięty.": "The widget has been removed.",
        "Widget został zduplikowany.": "Widget has been duplicated.",
        "Widget źródłowy": "Source widget",
        "Widoczna tylko dla redaktorów.": "Visible only to editors.",
        "Widoczna w menu witryny i w drzewie stron.": "Visible in site menu and page tree.",
        "Widoczna wyłącznie w panelu.": "Visible only in panel.",
        "widoczne": "visible",
        "Widoczne typy widgetów: %0": "Visible widget types: %0",
        "Widoczność": "Visibility",
        "Widoczność w wyszukiwarkach AI": "Visibility in AI search engines",
        "Widoczność zdjęcia": "Photo visibility",
        "Widok": "View",
        "Widok czołówki - zdjęcie z tytułem": "Front view - photo with title",
        "Widok narzędzi": "Tools view",
        "Widżety": "Widgets",
        "Widżety szablonu": "Template widgets",
        "Więcej": "More",
        "Witryna": "Website",
        "Witryna / Wersja językowa": "Website / Language version",
        "Witryna aktywna": "Active site",
        "Witryna docelowa": "Target site",
        "Witryna domyślna": "Default site",
        "Witryna i język": "Site and language",
        "Witryna internetowa": "Website",
        "Witryna określa dostępne szablony, języki i widgety.": "Site determines available templates, languages, and widgets.",
        "Witryna tylko dla zalogowanych użytkowników": "Site for logged-in users only",
        "Witryna została usunięta.": "The site has been removed.",
        "Witryna została zapisana.": "Site has been saved.",
        "Witryny": "Sites",
        "Wklej wartość Drugi klucz (MD5) z konfiguracji tego samego punktu płatności w PayU.": "Paste value of Second key (MD5) from configuration of same payment point in PayU.",
        "Wklej zawartość pliku JSON z kluczem konta usługi Google Cloud używanego do odczytu statystyk.": "Paste contents of JSON file with Google Cloud service account key used to read statistics.",
        "Włącz ankietę": "Enable survey",
        "Włącz cache": "Enable cache",
        "Włącz formularz kontaktowy": "Enable contact form",
        "Włącz przynajmniej jedną wersję językową dla witryny aby rozpocząć zarządzanie stronami.": "Enable at least one language version for your site to start managing your pages.",
        "Włącz publikację pliku llms.txt poniżej.": "Enable publication of llms.txt file below.",
        "Włącz social media": "Enable social media",
        "Włącz wszystkie": "Enable all",
        "Włącz, aby prezentować zdjęcie wraz z tytułem czołówki.": "Enable to display photo with lead title.",
        "Włącza komentarze dla wybranej witryny i wersji językowej. Pozostałe ustawienia określają dostęp i moderację.": "Enables comments for selected site and language version. Other settings determine access and moderation.",
        "Włączenie generowania pliku sitemap.xml dla całej witryny": "Enable sitemap.xml file generation for the website",
        "Włączenie protokołu SSL dla tej witryny": "Enable SSL for this site",
        "Włączone (Follow)": "Enabled (Follow)",
        "Włączone (Index)": "Enabled (Index)",
        "Właściwość ``%0`` aktywnego wpisu": "The ''%0'' feature of the active entry",
        "Właściwości": "Characteristics",
        "Własna częstotliwość zmian": "Custom change frequency",
        "Własna wartość": "Custom value",
        "Własne polecenie": "Custom instruction",
        "Własne reguły": "Custom rules",
        "Własne wymiary": "Custom dimensions",
        "Własny priorytet (od 0 do 1)": "Custom priority (from 0 to 1)",
        "Wpis został usunięty.": "The post has been deleted.",
        "Wpis został zaakceptowany.": "The post has been accepted.",
        "Wpis został zaktualizowany.": "The post has been updated.",
        "Wpisy dotyczą tylko tej witryny i zostaną dodane do robots.txt po zapisaniu. Początkowe reguły dotyczą User-agent: *. Dla konkretnego robota dodaj osobną sekcję User-agent. Puste pole zachowuje domyślny plik.": "Entries apply only to this site and will be added to robots.txt after saving. Initial rules apply to User-agent: *. To specify a particular bot, add a separate User-agent section. Leave this field empty to keep the default file.",
        "Wpisy zostały usunięte.": "The entries have been deleted.",
        "Wpisy zostały zaakceptowane.": "The entries have been accepted.",
        "Wpisz adres linku...": "Enter link URL...",
        "Wpisz kod HTML lub skrypt, który ma wyświetlać ten widżet.": "Enter HTML code or a script to display this widget.",
        "Wpisz tagi oddzielone przecinkami.": "Enter comma-separated tags.",
        "Wprowadź link": "Enter link",
        "Wprowadź poprawny obiekt JSON.": "Enter a valid JSON object.",
        "Wskaż stronę docelową i opcjonalne parametry adresu.": "Specify a destination page and optional URL parameters.",
        "Wskazany widget nie jest dynamicznym widgetem z formularzem.": "Selected widget is not a dynamic widget with a form.",
        "Wskazuje robotom wyszukiwarek czy mają indeksować stronę.": "It indicates to search engine robots whether to index the page.",
        "Wskazuje robotom wyszukiwarek czy mają podążać za linkami.": "It indicates to search engine robots whether to follow the links.",
        "Wspólne": "Shared",
        "Wstaw do edytora": "Insert into editor",
        "Wstaw do treści": "Insert into content",
        "Wstęp": "Introduction",
        "Wszystkie": "All",
        "Wszystkie kolumny będą wyświetlane jedna pod drugą.": "All columns will be displayed one below another.",
        "Wszystkie strony wybranej witryny i języka.": "All pages for selected site and language.",
        "Wszystko": "All",
        "Wtorek": "Tuesday",
        "Wybierz": "Select",
        "Wybierz adres kanoniczny z listy lub podaj ręcznie.": "Select a canonical address from the list or enter it manually.",
        "Wybierz ankietę": "Select a survey",
        "Wybierz aranżacje": "Select layouts",
        "Wybierz artykuł": "Select article",
        "Wybierz autora": "Select author",
        "Wybierz co najmniej jedną kategorię, do której użytkownik może się zapisać.": "Select at least one category that user can subscribe to.",
        "Wybierz czołówkę": "Choose a headlamp",
        "Wybierz datę": "Select a date",
        "Wybierz datę lub wprowadź wartość tekstową": "Select a date or enter a text value",
        "Wybierz docelowe aranżacje": "Select target layouts",
        "Wybierz dokument": "Select document",
        "Wybierz domyślną kategorię": "Choose a default category",
        "Wybierz etykietę": "Select label",
        "Wybierz formularz": "Select a form",
        "Wybierz gotową czołówkę. Przycisk obok otwiera jej pełną konfigurację.": "Select a ready-made header. Button next to it opens its full configuration.",
        "Wybierz grupę banerów, której elementy mają pojawić się w tym widżecie.": "Select banner group whose items should appear in this widget.",
        "Wybierz istniejącego użytkownika": "Select an existing user",
        "Wybierz język": "Select language",
        "wybierz katalog": "select directory",
        "Wybierz kategorie": "Select categories",
        "Wybierz listę regulaminów": "Select a list of regulations",
        "Wybierz listę stron": "Select page list",
        "Wybierz miejsce dla: %0": "Select location for: %0",
        "Wybierz odnośnik": "Select link",
        "Wybierz plik wideo z repozytorium albo wklej adres materiału.": "Select a video file from repository or paste a media URL.",
        "Wybierz podpowiedź albo wpisz własne polecenie – zmiana dotyczy wyłącznie zaznaczonego tekstu.": "Select a suggestion or enter your own prompt – change applies only to selected text.",
        "Wybierz pole, żeby przejść do edycji w podglądzie.": "Select a field to edit it in preview.",
        "Wybierz regulamin": "Select regulations",
        "Wybierz sekcję": "Select section",
        "Wybierz sekcję, której nazwę chcesz zmienić.": "Select section whose name you want to change.",
        "Wybierz sposób działania i prezentacji strony.": "Select how page works and is displayed.",
        "Wybierz stronę": "Select page",
        "Wybierz stronę do zatwierdzenia.": "Select a page to approve.",
        "Wybierz szablon": "Select template",
        "Wybierz szablon...": "Select template...",
        "Wybierz target": "Select target",
        "Wybierz treść": "Select content",
        "Wybierz typ aranżacji": "Select layout type",
        "Wybierz typ aranżacji do skonfigurowania.": "Select layout type to configure.",
        "Wybierz użytkownika": "Select user",
        "Wybierz widżet": "Select widget",
        "Wybierz widżet, aby sprawdzić jego konfigurację.": "Select a widget to check its configuration.",
        "Wybierz wiele": "Select multiple",
        "Wybierz witrynę": "Select site",
        "Wybierz witrynę i język": "Select site and language",
        "Wybierz z listy": "Select from list",
        "Wybierz…": "Select…",
        "wybór": "selection",
        "Wybór kategorii jest wymagany": "Category selection is required",
        "Wybór listy stron": "Selection of the list of pages",
        "Wybór strony": "Site selection",
        "Wybrana ikona powinna być kwadratem.": "Selected icon should be square.",
        "Wybrane ankiety zostały usunięte.": "Selected surveys have been deleted.",
        "Wybrane artykuły": "Items in cart",
        "Wybrane artykuły zostały usunięte.": "Selected articles have been deleted.",
        "Wybrane czołówki zostały usunięte.": "Selected headers have been deleted.",
        "Wybrane dokumenty zostały usunięte.": "Selected documents have been deleted.",
        "Wybrane etykiety zostały usunięte.": "Selected labels have been deleted.",
        "Wybrane galerie zostały usunięte.": "Selected galleries have been deleted.",
        "Wybrane gazetki zostały usunięte.": "Selected newsletters have been deleted.",
        "Wybrane kategorie zostały usunięte.": "Selected categories have been deleted.",
        "Wybrane linki wewnętrzne zostały usunięte.": "Selected internal links have been deleted.",
        "Wybrane linki zostały usunięte.": "Selected links have been deleted.",
        "Wybrane materiały wideo zostały usunięte.": "Selected videos have been deleted.",
        "Wybrane pytania zostały usunięte.": "Selected questions have been deleted.",
        "Wybrane regulaminy": "Selected terms and conditions",
        "Wybrane rotatory zostały usunięte.": "Selected rotators have been deleted.",
        "Wybrane strony": "Selected pages",
        "Wybrane subskrypcje zostały usunięte.": "Selected subscriptions have been deleted.",
        "Wybrane top tematy zostały usunięte.": "Selected trending topics have been deleted.",
        "Wybrane wpisy zostały usunięte.": "Selected entries have been deleted.",
        "Wybrani autorzy zostali usunięci.": "Selected authors have been deleted.",
        "Wybranie ankiety jest wymagane": "Selecting a survey is required",
        "Wybranie katalogu jest wymagane": "Selecting a directory is required",
        "Wybranie rotatora jest wymagane": "Selecting a rotator is required",
        "Wybranie strony jest wymagane": "Selecting a page is required",
        "Wybraniue modułu jest wymagane": "Selecting a module is required",
        "Wybraniue sekcji jest wymagane": "Selecting a section is required",
        "Wybrano": "Selected",
        "Wybrano etykietę \"Artykuł sponsorowany\".": "Selected label \"Sponsored article\".",
        "Wybrano etykietę \"Opinia\".": "Selected label \"Opinion\".",
        "Wybrano: {0}": "Selected: {0}",
        "Wybrany język": "Selected language",
        "Wybrany szablon": "Selected template",
        "Wybrany szablon witryny nie udostępnia żadnego układu.": "Selected site template does not provide any layouts.",
        "Wybrany znak zastąpi znacznik separatora | wstawiony w tytule.": "The selected character will replace the separator marker | inserted in the title.",
        "Wyczyść": "Clear",
        "Wyczyść wyszukiwanie": "Clear search",
        "Wydajność": "Performance",
        "Wygenerowane sloty dla widgetów": "Generated widget slots",
        "Wygeneruj definicję szablonu": "Generate template definition",
        "Wygeneruj krótki tytuł": "Generate short title",
        "Wygeneruj obraz z treści artykułu": "Generate image from article content",
        "Wygeneruj tytuł": "Generate title",
        "Wygeneruj wstęp": "Generate introduction",
        "Wygeneruj z nazwy autora": "Generate from author name",
        "Wygląd": "Look",
        "Wygląd wiadomości e-mail": "Email appearance",
        "Wyjaśnij prostym językiem najważniejsze pojęcia z treści": "Explain key concepts from content in simple language",
        "Wykonawca": "Author",
        "Wyłącz cenę": "Turn off the price",
        "Wyłącz cenę z historii": "Exclude price from history",
        "Wyłącz komentarze": "Disable comments",
        "Wyłącz skupienie": "Disable focus",
        "Wyłącz udostępnianie": "Disable sharing",
        "Wyłącz wszystkie": "Disable all",
        "Wyłącz, aby strona nie była dostępna w witrynie.": "Disable to make page unavailable on site.",
        "Wyłącz, aby ukryć widżet na stronie bez usuwania jego ustawień i zawartości.": "Disable to hide widget on page without removing its settings and content.",
        "Wyłączona": "Disabled",
        "Wyłączone (NoFollow)": "Off (NoFollow)",
        "Wyłączone (NoIndex)": "Disabled (NoIndex)",
        "Wyłączone komentarze": "Comments Off on",
        "Wyłączone przez:": "Disabled by:",
        "Wyłączone udostępnianie": "Disabled sharing",
        "Wyłączono focus widgetu": "Widget focus disabled",
        "Wyłączony autor nie jest widoczny na stronie.": "Disabled author is not visible on page.",
        "Wyliczana automatycznie (Omnibus).": "Calculated automatically (Omnibus).",
        "Wymaga logowania przed wyświetleniem treści witryny.": "Requires login before displaying site content.",
        "Wymaga ponownej akceptacji": "Requires reapproval",
        "Wymagaj ponownej akceptacji po zmianach": "Require re-approval after changes",
        "Wymagane": "Required",
        "Wymagane jest wybranie sekcji": "A section must be selected",
        "Wymagane jest wybranie wersji językowej": "It is required to select the language version",
        "Wymagane jest wybranie witryny": "It is required to select a site",
        "Wymagane jest wybranie zestawu regulaminów": "It is required to select a set of regulations",
        "Wymiar": "Dimension",
        "Wymiary strony": "Page dimensions",
        "Wyniki": "Results",
        "Wyniki ankiety": "Poll results",
        "Wyniki pojawią się po pierwszym oddanym głosie.": "Results will appear after first vote is cast.",
        "Wyniki_": "Results_",
        "Wypisz najważniejsze wnioski": "List key takeaways",
        "Wypisz znalezione błędy bez zmiany treści": "List errors found without changing content",
        "Wyrażone zgody": "Consents given",
        "Wyróżnia artykuł przy ustalaniu kolejności publikacji.": "Highlights article when determining publication order.",
        "Wyróżnik artykułu na listingach": "Article highlight on listings",
        "Wysłane": "Sent",
        "Wyślij wiadomość": "Send message",
        "Wysoki": "High",
        "Wysokość": "Height",
        "Wystąpił błąd": "An error occurred",
        "Wystąpiły błędy w formularzu. Sprawdź wszystkie pola formularza.": "There were errors in the form. Check all fields of the form.",
        "Wyświetla się, gdy adres nie prowadzi do istniejącej strony. Jest automatycznie ukryta w nawigacji.": "Displayed when the address does not lead to an existing page. Hidden from navigation automatically.",
        "Wyświetlaj listę artykułów z miniaturką zdjęcia": "Display a list of articles with a thumbnail image",
        "Wyświetlaj nazwę widgetu": "Display widget name",
        "Wyświetlaj opinie z tłem": "Display feedback with background",
        "Wyświetlaj tytuł": "Display title",
        "Wyświetlana jako przekreślona.": "Displayed with strikethrough.",
        "Wyświetlane na listingu i nad treścią": "Displayed on listing and above content",
        "Wyświetlane przy tym artykule": "Displayed with this article",
        "Wyświetlany na listingach i w stopce artykułu.": "Displayed on listings and in article footer.",
        "Wyświetlenia": "Views",
        "Wyszukaj": "Search",
        "Wyszukaj albo dodaj nową kategorię": "Search or add a new category",
        "Wyszukaj albo dodaj nowy tag": "Search for or add a new tag",
        "Wyszukaj autora i kliknij plus. Wybrane osoby pojawią się na liście widżetu.": "Search for an author and click plus. Selected people will appear in widget list.",
        "Wyszukaj autora...": "Search for author...",
        "Wyszukaj czołówkę...": "Search headline...",
        "Wyszukaj czołówkę…": "Search for a lead…",
        "Wyszukaj kategorię": "Search a category",
        "Wyszukaj kategorię...": "Search for a category...",
        "Wyszukaj regulamin…": "Search for terms and conditions…",
        "Wyszukaj treść": "Search content",
        "Wyszukaj widżet": "Search for a widget",
        "Wyszukiwanie zwraca tylko zaakceptowane wersje regulaminów.": "Search returns only approved versions of terms and conditions.",
        "Wyżej": "Above",
        "Wznawiam podgląd...": "Resuming preview...",
        "Wzór shortcode został usunięty.": "Shortcode template has been deleted.",
        "Wzór shortcode został zapisany.": "Shortcode template has been saved.",
        "Wzory": "Templates",
        "YouTube (ID)": "YouTube (ID)",
        "Z metadanych / generatora": "From metadata / generator",
        "Zaakceptowane": "Approved",
        "Zaakceptowane wersje": "Approved versions",
        "Zaakceptowany": "Accepted",
        "Zaawansowane polecenia": "Advanced commands",
        "Zaawansowany": "Advanced",
        "zacznij pisać aby wyszukać ankietę...": "start typing to search for a survey....",
        "zacznij pisać aby wyszukać ankiety...": "start writing to search for surveys....",
        "zacznij pisać aby wyszukać artykuł...": "start typing to search for an article...",
        "zacznij pisać aby wyszukać autora...": "start typing to search for an author...",
        "zacznij pisać aby wyszukać autora…": "start typing to search for an author…",
        "zacznij pisać aby wyszukać dokument...": "start typing to search for a document...",
        "zacznij pisać aby wyszukać galerię...": "start typing to search the gallery....",
        "zacznij pisać aby wyszukać grupę...": "start writing to search for a group....",
        "zacznij pisać aby wyszukać kategorię...": "start typing to search for a category...",
        "zacznij pisać aby wyszukać rotator...": "start typing to search for rotator....",
        "zacznij pisać aby wyszukać rotator…": "start typing to search for a rotator…",
        "zacznij pisać aby wyszukać wideo...": "start typing to search for video....",
        "Zacznij pisać, aby wyszukać autora…": "Start typing to search for an author…",
        "Zacznij pisać, aby wyszukać grupę…": "Start typing to search for a group…",
        "Zacznij pisać, aby wyszukać użytkownika…": "Start typing to search for a user…",
        "Zadaj pytanie lub wpisz polecenie": "Ask a question or enter a command",
        "Zaimportowano listę przekierowań.": "A list of redirects has been imported.",
        "Zakończone": "Completed",
        "Zakres": "Scope",
        "Załączniki": "Attachments",
        "Załączniki premium": "Premium attachments",
        "Zamiany zostały zapisane.": "The changes have been saved.",
        "Zamknięto edytor formularza": "Form editor closed",
        "Zamknięto edytor wpisu": "Post editor closed",
        "Zamknij": "Close",
        "Zamknij edytor": "Close editor",
        "Zamknij Live Design": "Close Live Design",
        "Zamknij panel skrótów albo boczny panel": "Close shortcuts panel or sidebar",
        "zamówień": "orders",
        "zamówienia": "orders",
        "Zamówienia": "Orders",
        "zamówienie": "order",
        "Zamówienie": "Order",
        "Zamówienie zostało zaktualizowane.": "The order has been updated.",
        "Zamówiony pakiet": "Ordered package",
        "Zapisano ustawienia kanałów RSS.": "RSS settings saved.",
        "Zapisz": "Save",
        "Zapisz aranżację": "Save layout",
        "Zapisz i wróć": "Save and return",
        "Zapisz lub odrzuć zmiany, aby zmienić witrynę.": "Save or discard changes to switch site.",
        "Zapisz ustawienia": "Save settings",
        "Zapisz zmiany": "Save changes",
        "Zaplanowana zmiana ceny": "Scheduled price change",
        "Zaplanowane": "Scheduled",
        "Zaproponuj trzy śródtytuły dla tej treści": "Suggest three subheadings for this content",
        "Zaproponuj tytuł i lead dla tej treści": "Suggest a title and lead for this content",
        "Zapytanie EQL": "EQL query",
        "Zarejestrowani użytkownicy": "Registered users",
        "Zarządzaj dostępem do strony w panelu.": "Manage page access in dashboard.",
        "Zarządzaj dostępem do tej witryny w panelu administracyjnym.": "Manage access to this site in admin panel.",
        "Zarządzaj kategoriami": "Manage categories",
        "Zarządzanie": "Management",
        "Zarządzanie witrynami": "Manage sites",
        "Zasady zgłaszania treści przez użytkowników.": "Rules for user content reporting.",
        "Zasoby": "Resources",
        "Zastąp": "Replace",
        "Zastąp fragment": "Replace fragment",
        "Zastosuj": "Apply",
        "Zatwierdź": "Approve",
        "Zawartość sekcji została zastąpiona w wybranych aranżacjach.": "Section content has been replaced in selected layouts.",
        "Zawiera sekcje": "Contains sections",
        "Zawierające jeden z wybranych tagów": "Containing one of the selected tags",
        "Zawsze": "Always",
        "Zaznacz tekst, aby wykonać operację AI.": "Select text to perform an AI operation.",
        "Zaznacz wszystkie": "Select all",
        "Zaznaczone": "Marked",
        "Zaznaczony fragment": "Selected fragment",
        "Zbuduj zawartość strony z sekcji i elementów.": "Build page content from sections and elements.",
        "Zdjęcia": "Photos",
        "Zdjęcia dostępne w ramach treści premium. Kolejność zmienisz przeciąganiem.": "Photos available as part of premium content. Drag to change order.",
        "Zdjęcia galerii": "Gallery photos",
        "Zdjęcie": "Photo",
        "Zdjęcie dla tabletów": "Photo for tablets",
        "Zdjęcie dla urządzeń mobilnych": "Photo for mobile devices",
        "Zdjęcie główne": "Main photo",
        "Zdjęcie główne nie jest widoczne w przypadku zaznaczenia opcji \"Tylko treść artykułu\".": "Main photo is not visible when \"Article content only\" is selected.",
        "Zdjęcie na okładce": "Cover photo",
        "Zdjęcie w tle": "Background photo",
        "Zdjęcie/ikonka": "Photo/icon",
        "Zduplikowano widget": "Widget duplicated",
        "Zestaw": "Set",
        "Zestaw niestandardowy": "Custom set",
        "Zestaw regulaminów prezentowany przy zapisie do subskrypcji.": "Set of terms and conditions displayed when subscribing.",
        "Zestaw został dodany.": "The set has been added.",
        "Zestaw został zaktualizowany.": "The set has been updated.",
        "Zewnętrzne skrypty statystyk": "External statistics scripts",
        "Zewnętrzne skrypty targetujące": "External targeting scripts",
        "Zewnętrzny": "External",
        "Zewnętrzny serwis": "External service",
        "Zezwalaj na odkrywanie treści": "Allow content discovery",
        "Zezwalaj na używanie treści przez AI": "Allow AI to use content",
        "Zgłaszanie": "Reporting",
        "Zgłaszanie komentarzy": "Reporting comments",
        "Zgłaszanie tylko po zalogowaniu": "Reporting only when logged in",
        "zgłoszeń": "reports",
        "Zgłoszenia": "Issues",
        "Zmiana formularza nie będzie możliwa po zapisaniu shortcode.": "Form cannot be changed after shortcode is saved.",
        "Zmiana nazwy nie zmienia identyfikatora sekcji ani jej umiejscowienia.": "Changing the name does not change the section ID or its location.",
        "Zmiana przenosi kategorię wraz z podkategoriami.": "Moving a category also moves its subcategories.",
        "Zmiana symbolu powoduje również zmianę adresu URL.": "Changing the symbol also changes the URL.",
        "Zmiana trybu układu": "Change layout mode",
        "Zmiana została zapisana.": "Change has been saved.",
        "Zmiany w tym widoku bezpośrednio wpływają na działanie aplikacji frontend. Upewnij się, że modyfikacje są przemyślane i uzasadnione.": "Changes in this view directly affect how frontend application works. Make sure modifications are considered and justified.",
        "Zmiany widżetu będą widoczne również w tych aranżacjach.": "Widget changes will also be visible in these layouts.",
        "Zmiany wpływają na frontend": "Changes affect frontend",
        "Zmiany zostały zapisane.": "Changes saved.",
        "Zmień daty publikacji": "Change publication dates",
        "Zmień nazwę": "Rename",
        "Zmień nazwę katalogu": "Rename folder",
        "Zmień nazwę kategorii": "Rename category",
        "Zmień tonalność i dodaj bezpośredni zwrot do czytelnika": "Change tone and address reader directly",
        "Zmień tonalność zaznaczonego fragmentu i uprość zdania": "Change tone of selected fragment and simplify sentences",
        "Zmień tonalność zaznaczonego fragmentu, pozostawiając terminologię": "Change tone of selected fragment while keeping terminology",
        "Zmień tonalność zaznaczonego fragmentu, zachowując treść": "Change tone of selected fragment while preserving content",
        "Zmieną %HEAD_TITLE% można wykorzystać w innych polach tekstowych.": "The variable %HEAD_TITLE% can be used in other text boxes.",
        "Zmieniono kolejność widgetów": "Widget order changed",
        "Zmienne": "Variables",
        "Znajdź typ widgetu...": "Find the type of widget...",
        "Znajdź typ widżetu": "Find widget type",
        "Znajdź widżet": "Find widget",
        "Znajdź widżet…": "Find widget…",
        "znaków": "characters",
        "Zobacz przed opublikowaniem": "View before publishing",
        "Zrezygnowano": "Canceled",
        "Źródło danych": "Data source",
        "Źródło URL": "URL source",
        "Źródło wideo": "Video source",
        "Źródło wideo premium": "Premium video source",
        "Zwięzła wersja do kafelków i list artykułów.": "Concise version for tiles and article lists.",
        "Zwiń panel podglądu": "Collapse preview panel",
        "Zwrot do nadawcy": "Return to sender"
    }
};
